import { Component, OnInit, Renderer2, Inject, ViewChild, ElementRef } from '@angular/core';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { JobsService } from 'src/app/service/jobs/jobs.service';
import { DepartmentService } from 'src/app/service/department/department.service';
import { DOCUMENT } from '@angular/common';
import { UsersService } from 'src/app/service/users/users.service';
import { OwnerInfoService } from 'src/app/service/owner-info/owner-info.service';
import { StatesService } from 'src/app/service/states/states.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { JobPermitTypeService } from 'src/app/service/job-permit-type/job-permit-type.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { JobAuditTrailService } from 'src/app/service/job-audit-trail/job-audit-trail.service';
import { IpAddressService } from 'src/app/service/ip-address/ip-address.service';
import { PotentialJobsDefaultCostCodeService } from 'src/app/service/potential-jobs-default-cost-code/potential-jobs-default-cost-code.service';
import { PotentialJobCostCodesService } from 'src/app/service/potential-job-cost-codes/potential-job-cost-codes.service';
import { PotentialJobCustomCostCodeService } from 'src/app/service/potential-job-custom-cost-code/potential-job-custom-cost-code.service';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { MediaService } from 'src/app/service/media/media.service';
import { ProjectTypeService } from 'src/app/service/project-type/project-type.service';
import { ProjectIndustryService } from 'src/app/service/project-industry/project-industry.service';
import { TaxStatusService } from 'src/app/service/tax-status/tax-status.service';
import { OrderPipe } from 'ngx-order-pipe';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { WorkingStatusService } from 'src/app/service/working-status/working-status.service';
import { CustomerService } from 'src/app/service/customer/customer.service';
import { BillingDueDateTypesService } from 'src/app/service/billing-due-date-types/billing-due-date-types.service';
import { InvoicesService } from 'src/app/service/invoices/invoices.service';
import { PdfService } from 'src/app/service/pdf/pdf.service';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';

@Component({
  selector: 'app-job-details',
  templateUrl: './job-details.component.html',
  styleUrls: ['./job-details.component.scss'],
})
export class JobDetailsComponent implements OnInit {
  @ViewChild('departmentCloseBtn') departmentCloseBtn;
  @ViewChild('deleteDepartmentModal') deleteDepartmentModal;
  @ViewChild('departmentAlertCloseBtn') departmentAlertCloseBtn;
  @ViewChild('removeDepartmentAlert') removeDepartmentAlert;
  @ViewChild('costCodeCloseBtn') costCodeCloseBtn;
  @ViewChild('fileUploadCloseBtn') fileUploadCloseBtn;
  @ViewChild('dropZoneFile') dropZoneFile;
  @ViewChild('htmlData') htmlData: ElementRef;
  @ViewChild('showSubmitToAccountingModal') showSubmitToAccountingModal;
  @ViewChild('supplementalInfo') supplementalInfo;
  @ViewChild('contact_ar_customer_name_id') contact_ar_customer_name_id;
  @ViewChild('owner_id') owner_id;
  @ViewChild('generalTab') generalTab;
  @ViewChild('hidden1') hidden1;
  @ViewChild('hidden2') hidden2;

  jobId;
  jobDetail;
  jobDetailForm: FormGroup;
  jobDepartmentCostCodeDetailForm: FormGroup;
  jobDepartmentCustomCostCodeDetailForm: FormGroup;
  jobDepartmentCostCodeForm: FormGroup;
  departmentsData;
  jobDepartmentData;
  jobDepartmentFormData;
  projectManagerData: any = [];
  ProjectAssistantData: any = [];
  projectForemanData: any = [];
  projectEstimatorData: any = [];
  ownersData: any = [];
  ownersFacilityData: any = [];
  arCustomerData: any = [];
  unionLocalsData: any = [];
  permitTypesData: any = [];
  workingStatusData: any = [];
  billingDueDateTypesData: any = [];
  statesData;
  selectedDepartment;
  disableBakcupFields = false;
  deleteDepartmentIds = [];
  customJobCreationDate;
  deleteDepartmentId;
  clickedInlineCheckbox;
  confirmedRemove = false;
  auditTrailData: any = [];
  ipAddress;
  userId;
  jobDepartmentCostCodeData;
  jobDepartmentCustomCostCodeData;
  jobDefaultCostCodeData;
  jobDepartmentTaskCodes: any = [];
  jobDepartmentCustomCostCodes: any = [];
  lastJobCostCodeDeparrmentSelection;
  lastPotentialJobId;
  deleteDepartmentCostCodeId = [];
  grandContractTotal = 0;
  grandEstimatedCost = 0;
  grandEstimatedProfit = 0;
  grandEstimatedGm = 0;
  grandEstimatedHours = 0;
  grandProdUnits = 0;
  costCodesLoaded = false;
  fileList = [];

  lastFileUploadSection;
  projectTypeData: any = [];
  projectIndustryData: any = [];
  taxStatusData: any = [];

  form: FormGroup;

  ngModelCount: number = 0;

  isHovering: boolean;

  attachSchedulefiles: File[] = [];
  userPermissions;
  permissionMap: any = {
    general_info: { edit: 0, view: 0 },
    billing_accounting: { edit: 0, view: 0 },
    financials: { edit: 0, view: 0 },
    audit_trail: { edit: 0, view: 0 },
    working_status: { edit: 0, view: 0 },
  };
  task: AngularFireUploadTask;

  percentage: Observable<number>;
  snapshot: Observable<any>;
  downloadURL;

  selectedFileUploadMode;

  mainJobId;

  working_status_data;
  pageLoaded = false;
  detailDataLoaded = false;

  detailData;

  oldWorkingStatus;
  jobCrationDate;
  markDirty = false;
  isActiveWorkingStatus = false;
  disableSave = false;
  initialValue;
  lockedFieldChanges = {};
  isDeleted = false;
  enableTabBondRequired = false;
  enableTabInsuranceRequired = false;
  disbleTabPerDiem = false;
  disableTabUnionTargeting = false;
  initGeneral = true;
  lastOwner;
  jobCreationData;
  lastSubmitToAccountingText = '';
  disableOnSetUpComplete = false;
  isSubmitToAccounting = false;
  invoiceStatusData = [];
  invoiceStatusDescription = [];
  billingContacts = [];

  constructor(
    private formBuilder: FormBuilder,
    private departmentsService: DepartmentService,
    private localStorageService: LocalstorageService,
    private route: ActivatedRoute,
    private router: Router,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document,
    private jobsService: JobsService,
    private usersService: UsersService,
    private ownerInfoService: OwnerInfoService,
    private statesServices: StatesService,
    private momentService: MomentService,
    private jobPermitTypeService: JobPermitTypeService,
    private toastService: ToastService,
    private jobAuditTrailService: JobAuditTrailService,
    private ipAddressService: IpAddressService,
    private potentialJobCostCodesService: PotentialJobCostCodesService,
    private potentialJobsDefaultCostCodeService: PotentialJobsDefaultCostCodeService,
    private potentialJobsCustomCostCodeService: PotentialJobCustomCostCodeService,
    private storage: AngularFireStorage,
    private projectTypeService: ProjectTypeService,
    private projectIndustryService: ProjectIndustryService,
    private workingStatusService: WorkingStatusService,
    private billingDueDateTypesService: BillingDueDateTypesService,
    private taxStatusService: TaxStatusService,
    private orderPipe: OrderPipe,
    private loaderService: LoaderService,
    private customerService: CustomerService,
    private invoicesService: InvoicesService,
    private pdfService: PdfService,
    private mediaService: MediaService,
  ) {
    this.userId = this.localStorageService.getItem('userId');
    this.disableFormGroupByRole();
  }

  ngOnInit(): void {
    this.fileList['labor_attach_schedule'] = [];
    this.fileList['sales_tax_attach_exemption_certificate'] = [];
    this.fileList['additional_per_diem_documents'] = [];
    this.fileList['additional_attach_targeting_contact'] = [];
    this.fileList['labor_attach_schedule_filenames'] = [];
    this.fileList['contract_attach_project_purchase_order'] = [];
    this.fileList['financial_attach_other_document'] = [];
    this.fileList['sales_tax_attach_exemption_certificate_filenames'] = [];
    this.fileList['additional_per_diem_documents_filenames'] = [];
    this.fileList['additional_attach_targeting_contact_filenames'] = [];
    this.fileList['contract_attach_project_purchase_order_filenames'] = [];
    this.fileList['financial_attach_other_document_filenames'] = [];
    this.fileList['labor_attach_schedule_media_ids'] = [];
    this.fileList['sales_tax_attach_exemption_certificate_media_ids'] = [];
    this.fileList['additional_per_diem_documents_media_ids'] = [];
    this.fileList['additional_attach_targeting_contact_media_ids'] = [];
    this.fileList['contract_attach_project_purchase_order_media_ids'] = [];
    this.fileList['financial_attach_other_document_media_ids'] = [];

    this.route.params.subscribe(params => {
      this.jobId = params['id'];
    });
    this.getInvoiceDescriptions();
    this.getBillingDueDateTypes();
    //Function call to get job permit type data
    this.getJobPermitType();
    //Function call to get all users data
    this.getUsers();
    //Function call to get owners data
    this.getOwners();
    //Function call to get states data
    this.getStates();
    //Function call to get project type data
    this.getProjectType();
    //Function call to get project industry data
    this.getProjectIndustry();
    //Function call to get tax status data
    this.getTaxStatus();
    //Function call to get arcustomer data
    this.getARCustomer();
    //Function call to get union locals data
    this.getUnionLocals();
    setTimeout(() => {
      this.getJobDetails();
    }, 1500);
    this.userPermissions = getAndParseUserPermissions(this.localStorageService);

    //Function call to get client ip address
    this.getIP();
    this.disableFormGroupByRole();
    this.form = this.formBuilder.group({
      count: 0,
    });
    setTimeout(() => {
      this.loadScroller();
      this.loadtextAreaPlaceHolder();
    }, 2000);
  }

  checkTabEditPermission(page) {
    if (this.permissionMap[page]) {
      if (!this.permissionMap[page]['edit']) {
        this.disableSave = true;
        if (page == 'general_info') {
          this.loadSelect2('.workingStatus', false);
          this.loadSelect2('.isEditableGeneralSelect', false);
        } else if (page == 'billing_accounting') {
          this.loadSelect2('.workingStatus', false);
          this.loadSelect2('.isEditableBillingSelect', false);
        } else if (page == 'financials') {
          this.loadSelect2('.workingStatus', false);
        } else if (page == 'audit_trail') {
          this.loadSelect2('.workingStatus', false);
        }
        if (this.isSubmitToAccounting) {
          this.loadErrorStatus();
        }
      } else {
        this.disableSave = false;
        setTimeout(() => {
          if (page == 'general_info') {
            this.initGeneral = true;
            this.hidden1.nativeElement.focus();
            this.loadAutoFocus('#owner_id', true);
            this.loadSelect2('.workingStatus', true);
            this.loadSelect2('.isEditableGeneralSelect', true);
          } else if (page == 'billing_accounting') {
            this.hidden2.nativeElement.focus();
            this.loadAutoFocus('#contact_ar_customer_name_id', true);
            this.loadSelect2('.workingStatus', true);
            if (!this.isActiveWorkingStatus && !this.isDeleted) {
              this.loadSelect2('.isEditableBillingSelect', true);
              this.loadSelect2('.billingAccountingLocked', true);
              this.loadSelect2Num('.select2Num', true);
            }
            this.setNextElementFocus();
          } else if (page == 'financials') {
            this.supplementalInfo.nativeElement.focus();
            this.loadSelect2('.workingStatus', true);
          } else if (page == 'audit_trail') {
            this.loadSelect2('.workingStatus', true);
          }
          if (this.isSubmitToAccounting) {
            this.loadErrorStatus();
          }
        }, 300);
      }
    } else {
      this.disableSave = false;
    }
    setTimeout(() => {
      this.loadScroller();
    }, 500);
  }

  loadScroller() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadScroller();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2(obj = null, status = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2('` + obj + `',` + status + `);`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2Num(obj = null, status = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2Num('` + obj + `',` + status + `);`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadAutoFocus(obj, isSelect = false) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadAutoFocus('` + obj + `',` + isSelect + `);`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadtextAreaPlaceHolder() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadtextAreaPlaceHolder();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadDatePicker(className = null, altField = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    if (className != null) {
      s.text = `loadDatePicker('` + className + `','` + altField + `');`;
    } else {
      s.text = `loadDatePicker()`;
    }
    this.renderer2.appendChild(this._document.body, s);
  }

  loadCheckedOnEnter() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadCheckedOnEnter();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  setNextElementFocus() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `setNextElementFocus();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2Error() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2Error();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  closeModal(id: string | number) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `closeModal('` + id + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  enableDisableSelect2(obj, status = false) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `enableDisableSelect2('` + obj + `', ` + status + `);`;
    this.renderer2.appendChild(this._document.body, s);
  }

  clearFile(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearFile('` + obj + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  disableRadio(obj = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `disableFields('.disableRadioOnSetUpComplete');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  enableRadio(obj = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `enableFields('.disableRadioOnSetUpComplete');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To create job details form
  createJobDetailForm(data = null) {
    if (!data) return;

    //Generate form group with job detail data by id
    this.customJobCreationDate = data.job_creation_date;
    this.disableBakcupFields = data.additional_backup_required ? true : false;
    this.working_status_data = data.working_status;
    this.oldWorkingStatus = data.working_status;
    this.jobCrationDate = data.job_creation_date;
    this.isDeleted = data.status == 0 ? true : false;
    this.jobCreationData = this.momentService.getGeneralDateFormat(data.job_creation_date);

    let projectTypeSelction = data.project_type_id != null ? data.project_type_id : 1;
    let projectIndustrySelection = data.project_industry_id ? data.project_industry_id : 0;

    this.jobDetailForm = this.formBuilder.group(
      {
        id: this.jobId,
        //General info
        number: [data.number],
        name: [data.name, Validators.required],
        submitted_by_name: [data.submitted_by_name, Validators.required],
        owner_id: [data.owner_id != '' ? data.owner_id : 0, Validators.required],
        facility_location_id: [data.facility_location_id != '' ? data.facility_location_id : 0, Validators.required],
        description: [data.description, Validators.required],
        start_date: [
          data.start_date != null && data.start_date != '' && data.start_date != undefined
            ? this.momentService.formateDate(data.start_date)
            : null,
          Validators.required,
        ],
        end_date: [
          data.end_date != null && data.end_date != '' && data.end_date != undefined
            ? this.momentService.formateDate(data.end_date)
            : null,
          Validators.required,
        ],
        project_type_id: [projectTypeSelction, Validators.required],
        project_industry_id: [projectIndustrySelection, Validators.required],
        is_precon_involved: [data.is_precon_involved, Validators.required],
        turnover_complete: [data.turnover_complete, Validators.required],
        turnover_completion_date: [
          data.turnover_completion_date != null &&
          data.turnover_completion_date != '' &&
          data.turnover_completion_date != undefined
            ? this.momentService.formateDate(data.turnover_completion_date)
            : null,
        ],
        address1: [data.address1],
        address2: [data.address2],
        city: [data.city],
        state_id: [data.state_id],
        postal_code: [data.postal_code],
        code: [data.code],
        working_status: [data.working_status],
        department: this.formBuilder.array([this.addAdditionalInfoRows(this.jobDepartmentData)]),
        //Billing and accouting
        contact_ar_customer_name_id: [data.contact_ar_customer_name_id, Validators.required],
        contact_ar_customer_id: [data.contact_ar_customer_id, Validators.required],
        contact_address1: [data.contact_address1, Validators.required],
        contact_address2: [data.contact_address2],
        contact_city: [data.contact_city],
        contact_state_id: [data.contact_state_id],
        contact_postal_code: [data.contact_postal_code],
        contact_purchse_order: [data.contact_purchse_order, Validators.required],
        contact_type_of_billing: [data.contact_type_of_billing ? data.contact_type_of_billing : 1, Validators.required],
        contact_retainage_per: [data.contact_retainage_per, Validators.required],
        contact_billing_due_date_type: [data.contact_billing_due_date_type, Validators.min(1)],
        contact_tm: [data.contact_tm],
        contact_notes: [data.contact_notes],
        contract_attach_project_purchase_order: [data.contract_attach_project_purchase_order],
        contract_attach_project_purchase_order_filenames: [data.contract_attach_project_purchase_order_filenames],
        labor_union_local_id: [data.labor_union_local_id, Validators.required],
        labor_alert_accounting_to_new_union: [data.labor_alert_accounting_to_new_union],
        labor_union_notes: [data.labor_union_notes],
        labor_certified_payroll: [data.labor_certified_payroll],
        labor_prevailing_wage: [data.labor_prevailing_wage],
        labor_attach_schedule: [data.labor_attach_schedule],
        labor_attach_schedule_filenames: [data.labor_attach_schedule_filenames],
        labor_per_diem: [data.labor_per_diem],
        labor_per_diem_notes: [data.labor_per_diem_notes],
        sales_tax_status_id: [data.sales_tax_status_id ? data.sales_tax_status_id : 1],
        sales_tax_exemption_notes: [data.sales_tax_exemption_notes],
        sales_tax_attach_exemption_certificate: [data.sales_tax_attach_exemption_certificate],
        sales_tax_attach_exemption_certificate_filenames: [data.sales_tax_attach_exemption_certificate_filenames],
        additional_billing_contact_name: [data.additional_billing_contact_name],
        additional_contact_email: [data.additional_contact_email, Validators.email],
        additional_contact_phone_number: [data.additional_contact_phone_number],
        billing_contacts_preferred_index: [data?.billing_contacts_preferred_index ?? 0],
        additional_invoice_delivery_method: [
          data.additional_invoice_delivery_method != null &&
          data.additional_invoice_delivery_method != '' &&
          data.additional_invoice_delivery_method != undefined
            ? data.additional_invoice_delivery_method
            : 2,
        ],
        additional_portal_website_address: [data.additional_portal_website_address, { disabled: true }],
        additional_portal_login: [data.additional_portal_login],
        additional_portal_password: [data.additional_portal_password],
        additional_backup_required: [data.additional_backup_required],
        additional_sworn_statement: [data.additional_sworn_statement],
        additional_waivers: [data.additional_waivers],
        additional_tm_backup: [data.additional_tm_backup],
        additional_timesheets: [data.additional_timesheets],
        additional_other: [data.additional_other],
        additional_portal_notes: [data.additional_portal_notes],
        additional_contact_signed: [data.additional_contact_signed],
        additional_ocip: [data.additional_ocip],
        additional_ocip_website_address: [data.additional_ocip_website_address],
        additional_portal_login_address: [data.additional_portal_login_address],
        additional_union_targeting: [data.additional_union_targeting],
        additional_date_contract_requested: [
          data.additional_date_contract_requested != null &&
          data.additional_date_contract_requested != '' &&
          data.additional_date_contract_requested != undefined
            ? this.momentService.getGeneralDateFormat(data.additional_date_contract_requested)
            : null,
        ],
        additional_per_diem_documents: [data.additional_per_diem_documents],
        additional_per_diem_documents_filenames: [data.additional_per_diem_documents_filenames],
        additional_attach_targeting_contact: [data.additional_attach_targeting_contact],
        additional_attach_targeting_contact_filenames: [data.additional_attach_targeting_contact_filenames],
        additional_bond_required: [data.additional_bond_required],
        additional_bond_received_date: [
          data.additional_bond_received_date != null &&
          data.additional_bond_received_date != '' &&
          data.additional_bond_received_date != undefined
            ? this.momentService.getGeneralDateFormat(data.additional_bond_received_date)
            : null,
        ],
        additional_bond_signed_date: [
          data.additional_bond_signed_date != null &&
          data.additional_bond_signed_date != '' &&
          data.additional_bond_signed_date != undefined
            ? this.momentService.getGeneralDateFormat(data.additional_bond_signed_date)
            : null,
        ],
        additional_bond_sent_date: [
          data.additional_bond_sent_date != null &&
          data.additional_bond_sent_date != '' &&
          data.additional_bond_sent_date != undefined
            ? this.momentService.getGeneralDateFormat(data.additional_bond_sent_date)
            : null,
        ],
        additional_insurance_cert_required: [data.additional_insurance_cert_required],
        additional_insurance_cert_received_date: [
          data.additional_insurance_cert_received_date != null &&
          data.additional_insurance_cert_received_date != '' &&
          data.additional_insurance_cert_received_date != undefined
            ? this.momentService.getGeneralDateFormat(data.additional_insurance_cert_received_date)
            : null,
        ],
        additional_insurance_cert_sent_date: [
          data.additional_insurance_cert_sent_date != null &&
          data.additional_insurance_cert_sent_date != '' &&
          data.additional_insurance_cert_sent_date != undefined
            ? this.momentService.getGeneralDateFormat(data.additional_insurance_cert_sent_date)
            : null,
        ],
        additional_permits_required: [data.additional_permits_required],
        additional_permit_types: [data.additional_permit_types],
        updated_date: this.momentService.getDBDateTimeFormat(),
        permit_type: this.formBuilder.array([this.addAdditionalPermitTypeInfoRows(this.permitTypesData)]),
        financial_supplemental_info: [data.financial_supplemental_info],
        financial_notes: [data.financial_notes],
        financial_attach_other_document: [data.financial_attach_other_document],
        financial_attach_other_document_filenames: [data.financial_attach_other_document_filenames],
        sage_export_name: [data.sage_export_name],
      },
      {
        validator: [
          this.dateCompareValidator('start_date', 'end_date'),
          this.confirmedValidator('additional_union_targeting', 'additional_date_contract_requested'),
        ],
      },
    );

    this.fileList['labor_attach_schedule'] = data.labor_attach_schedule ? data.labor_attach_schedule.split(',') : '';
    this.fileList['sales_tax_attach_exemption_certificate'] = data.sales_tax_attach_exemption_certificate
      ? data.sales_tax_attach_exemption_certificate.split(',')
      : '';
    this.fileList['additional_per_diem_documents'] = data.additional_per_diem_documents?.split(',') || '';
    this.fileList['additional_attach_targeting_contact'] = data.additional_attach_targeting_contact
      ? data.additional_attach_targeting_contact.split(',')
      : '';
    this.fileList['contract_attach_project_purchase_order'] = data.contract_attach_project_purchase_order
      ? data.contract_attach_project_purchase_order.split(',')
      : '';
    this.fileList['financial_attach_other_document'] = data.financial_attach_other_document
      ? data.financial_attach_other_document.split(',')
      : '';
    this.fileList['labor_attach_schedule_filenames'] = data.labor_attach_schedule_filenames
      ? data.labor_attach_schedule_filenames.split(',')
      : '';
    this.fileList['sales_tax_attach_exemption_certificate_filenames'] =
      data.sales_tax_attach_exemption_certificate_filenames
        ? data.sales_tax_attach_exemption_certificate_filenames.split(',')
        : '';
    this.fileList['additional_per_diem_documents_filenames'] =
      data.additional_per_diem_documents_filenames?.split(',') || '';
    this.fileList['additional_attach_targeting_contact_filenames'] = data.additional_attach_targeting_contact_filenames
      ? data.additional_attach_targeting_contact_filenames.split(',')
      : '';
    this.fileList['contract_attach_project_purchase_order_filenames'] =
      data.contract_attach_project_purchase_order_filenames
        ? data.contract_attach_project_purchase_order_filenames.split(',')
        : '';
    this.fileList['financial_attach_other_document_filenames'] = data.financial_attach_other_document_filenames
      ? data.financial_attach_other_document_filenames.split(',')
      : '';

    if (data.owner_id) {
      this.getOwnerInfo(data.owner_id);
      this.setSelectedFacilityAddress(data.facility_location_id);
    }

    setTimeout(() => {
      this.loadDatePicker('#start_date', '.start_date');
      this.loadDatePicker('#end_date', '.end_date');
    }, 1000);
  }

  // Add additional data in department form
  addAdditionalInfoRows(data = null) {
    /* Add new rows to existing dates */
    const group = this.formBuilder.group({
      sub_department: this.formBuilder.array([]),
    });

    //If data exist, set data in department form
    if (data != null) {
      data.forEach(element => {
        this.addAdditionalInfoSameEditTime(group.controls.sub_department, element);
      });
    } else {
      this.addAdditionalInfoSameEditTime(group.controls.sub_department, data);
    }

    return group;
  }

  // Add form parameter in group
  addAdditionalInfoSameEditTime(department: any, data = null) {
    /* Add new requests to existing dates */ //debugger
    let group;

    if (data != null) {
      //If data exist, set data in fields
      group = this.formBuilder.group({
        project_manager_id: [data.project_manager_id, Validators.required],
        assistant_id: [data.assistant_id, Validators.required],
        partner_assistant_id: [data.partner_assistant_id],
        foreman_id: [data.foreman_id, Validators.required],
        estimator_id: [data.estimator_id],
        notes: [data.notes],
        id: [data.job_id],
        job_details_id: this.jobId,
        is_main_job: [data.is_main_job],
        department_name: [data.department_name],
        department_id: [data.department_id],
        number: [data.number],
        contract_total: [data.contract_total],
        department_short_code: [data.department_short_code],
        updated_date: this.momentService.getDBDateTimeFormat(),
      });

      department.push(group);
    } else {
      //To create new sub department in view
      group = this.formBuilder.group({
        project_manager_id: [null, Validators.required],
        assistant_id: [null, Validators.required],
        partner_assistant_id: [null, Validators.required],
        foreman_id: [null, Validators.required],
        estimator_id: [null],
        notes: [null],
        id: [''],
        is_main_job: [null],
        job_details_id: this.jobId,
        department_name: [this.selectedDepartment.department_name],
        department_id: [this.selectedDepartment.id],
        number: [this.jobDetailForm.get('number').value],
        contract_total: [],
        department_short_code: [this.selectedDepartment.department_short_code],
        created_date: this.momentService.getDBDateTimeFormat(),
        updated_date: this.momentService.getDBDateTimeFormat(),
      });

      this.selectedDepartment = '';
      department.push(group);
    }

    setTimeout(() => {
      if (this.isActiveWorkingStatus) {
        this.disableOnSetUpComplete = true;
        this.disableRadio();
      } else {
        this.disableOnSetUpComplete = false;
        this.enableRadio();
      }
      if (!this.isActiveWorkingStatus && !this.isDeleted) {
        this.activateLockedFields();
      }
      if (!this.isDeleted) {
        this.activateDisabledField();
      }
      this.triggerChange('#project_industry_id_select');
    }, 500);
  }

  // Add additional data in permit type form
  addAdditionalPermitTypeInfoRows(data = null) {
    /* Add new rows to existing dates */

    const group = this.formBuilder.group({
      indi_permittype: this.formBuilder.array([]),
    });

    //If data exist, set data in permit type form
    if (data != null) {
      data.forEach(element => {
        this.addAdditionalPermitTypeInfoSameEditTime(group.controls.indi_permittype, element);
      });
    } else {
      this.addAdditionalPermitTypeInfoSameEditTime(group.controls.indi_permittype, data);
    }

    return group;
  }

  // Add form parameter in group
  async addAdditionalPermitTypeInfoSameEditTime(permitType: any, data = null) {
    /* Add new requests to existing dates */ //debugger
    let group;
    if (data != null) {
      //If data exist, set data in fields
      group = this.formBuilder.group({
        id: [data.id],
        job_details_id: [data.job_details_id],
        permit_type: [data.permit_type],
        record_date: [
          data.record_date != null && data.record_date != '' && data.record_date != undefined
            ? this.setDateString(data.record_date)
            : null,
        ],
        updated_date: this.momentService.getDBDateTimeFormat(),
      });

      permitType.push(group);
    } else {
      const newPermitType = {
        job_details_id: [this.jobId],
        permit_type: '',
        record_date: '',
        created_date: this.momentService.getDBDateTimeFormat(),
        updated_date: this.momentService.getDBDateTimeFormat(),
      };

      const newData = await this.addPermitType(newPermitType);

      if (newData) {
        newPermitType['id'] = newData['data'].id;
      }

      //To create new permit type in view
      group = this.formBuilder.group(newPermitType);

      permitType.push(group);
    }
    setTimeout(() => {
      this.loadDatePicker();
      this.markDirty = true;
      this.jobDetailForm.get('permit_type').markAsDirty;
    }, 100);
  }

  setDateString(date) {
    const date1 = date.slice(0, 10);
    const newDate = date1.split('-');
    return newDate[1] + '/' + newDate[2] + '/' + newDate[0];
  }

  //To get job details by id
  getJobDetails() {
    this.jobsService.getJobById(this.jobId, true, false).subscribe(
      res => this.onSuccess(res),
      error => this.onError(error),
    );
  }

  getContacts(billingContacts) {
    if (typeof billingContacts === 'string') {
      return JSON.parse(billingContacts)?.contacts ?? [];
    }

    return billingContacts?.contacts ?? [];
  }

  //On success of api call
  onSuccess(result) {
    if (!result?.data) {
      this.jobDetail = result.errors;
      this.departmentsData = '';
      return;
    }

    this.jobDetail = result.data[0];

    const contacts = this.getContacts(result.data[0]?.billing_contacts);

    if (!this.billingContacts?.length) {
      this.billingContacts = contacts;
    }

    this.loadSelect2('.workingStatus', true);
    if (this.jobDetail['working_status'] == 5) {
      this.isActiveWorkingStatus = true;
    } else {
      this.isActiveWorkingStatus = false;
      if (this.jobDetail['status'] != 0) {
        this.activateLockedFields();
      }
    }
    if (this.jobDetail['status'] == 0) {
      this.loadSelect2('.aditionalSelect2', false);
    } else {
      this.loadSelect2('.aditionalSelect2', true);
    }
    this.checkTabEditPermission('general_info');
    this.jobDepartmentData = result.data;
    this.initialValue = result.data;

    this.createJobDetailForm(this.jobDetail);
    //Function call to get cost code data
    this.getJobDepartmentCostCode();
    this.getCustomCostCodeData();
    this.getJobAuditTrail();
    this.getDepartments();

    const preferredIndex = result.data[0]?.billing_contacts_preferred_index ?? 0;
    const preferredContact = contacts[preferredIndex] || {
      contactName: '',
      contactEmail: '',
      billingEmail: '',
      phoneNumber: '',
      billingNote: '',
    };

    const selectedContact = {
      contactName: preferredContact.contactName,
      contactEmail: result.data[0].additional_contact_email || preferredContact.contactEmail,
      billingEmail: result.data[0].additional_portal_website_address || preferredContact.billingEmail,
      phoneNumber: result.data[0].additional_contact_phone_number || preferredContact.phoneNumber,
      billingNote: result.data[0].additional_portal_notes || preferredContact.billingNote,
    };

    this.jobDetailForm.get('additional_billing_contact_name').setValue(selectedContact.contactName);
    this.jobDetailForm.get('additional_contact_email').setValue(selectedContact.contactEmail);
    this.jobDetailForm.get('additional_contact_phone_number').setValue(selectedContact.phoneNumber);
    this.jobDetailForm.get('additional_portal_website_address').setValue(selectedContact.billingEmail);
    this.jobDetailForm.get('additional_portal_notes').setValue(selectedContact.billingNote);

    setTimeout(() => {
      this.loadDatePicker();
      this.loadScroller();
    }, 500);

    this.loadS3MediaForJob();

    this.markDirty = false;
  }

  loadS3MediaForJob() {
    const sections = [
      'financial_attach_other_document',
      'contract_attach_project_purchase_order',
      'labor_attach_schedule',
      'additional_per_diem_documents',
      'additional_attach_targeting_contact',
      'sales_tax_attach_exemption_certificate',
    ];

    sections.forEach(section => {
      this.jobsService.getJobMedia(this.jobId, section).subscribe(res => {
        const records: any[] = res?.data || [];

        if (records.length > 0) {
          this.fileList[section] = [];
          this.fileList[section + '_filenames'] = [];
          this.fileList[section + '_media_ids'] = [];

          records.forEach(record => {
            this.fileList[section].push(record.url);
            this.fileList[section + '_filenames'].push(record.name);
            this.fileList[section + '_media_ids'].push(record.id);
          });
        }
      });
    });
  }

  //On error of api call
  onError(error) {}

  activateDisabledField() {
    this.loadSelect2('.deletedLocked', true);
  }

  activateLockedFields() {
    this.enableRadio();
    this.isActiveWorkingStatus = false;
    this.loadSelect2('.generalLocked', true);
    this.loadSelect2('.aditionalSelect2', true);
    this.loadSelect2('.billingAccountingLocked', true);
    this.loadSelect2Num('.select2Num', true);

    setTimeout(() => {
      if (this.permissionMap.general_info) {
        if (this.permissionMap.general_info['edit']) {
          this.jobDetailForm.get('owner_id').enable();
          this.jobDetailForm.get('facility_location_id').enable();
          this.loadSelect2('.aditionalSelect2', true);
          this.loadSelect2('.generalLocked', true);
          this.loadSelect2('.isEditableGeneralSelect', true);
        } else {
          this.jobDetailForm.get('owner_id').disable();
          this.jobDetailForm.get('facility_location_id').disable();
          this.loadSelect2('.aditionalSelect2', false);
          this.loadSelect2('.generalLocked', false);
          this.loadSelect2('.isEditableGeneralSelect', false);
        }
      }

      if (this.permissionMap.billing_accounting) {
        if (this.permissionMap.billing_accounting['edit']) {
          this.jobDetailForm.get('contact_ar_customer_name_id').enable();
          this.jobDetailForm.get('contact_ar_customer_id').enable();
          this.jobDetailForm.get('contact_type_of_billing').enable();
          this.jobDetailForm.get('labor_union_local_id').enable();
          this.jobDetailForm.get('sales_tax_status_id').enable();

          this.loadSelect2('.billingAccountingLocked', true);
          this.loadSelect2Num('.select2Num', true);
          this.loadSelect2('.isEditableBillingSelect', true);
        } else {
          this.jobDetailForm.get('contact_ar_customer_name_id').disable();
          this.jobDetailForm.get('contact_ar_customer_id').disable();
          this.jobDetailForm.get('contact_type_of_billing').disable();
          this.jobDetailForm.get('labor_union_local_id').disable();
          this.jobDetailForm.get('sales_tax_status_id').disable();
          this.loadSelect2('.billingAccountingLocked', false);
          this.loadSelect2Num('.select2Num', false);
          this.loadSelect2('.isEditableBillingSelect', false);
        }
      }
      if (this.isSubmitToAccounting) {
        this.loadErrorStatus();
      }
    }, 500);
  }

  //To get all departments
  getDepartments() {
    //Service call to get all departments data
    this.departmentsService.getDepartments(false, true).subscribe(
      res => this.onDepartmentSuccess(res),
      error => this.onDepartmentsError(error),
    );
  }

  //On success of departments api call
  onDepartmentSuccess(result) {
    if (result) {
      if (result.data) {
        //Function call to get working status data
        this.getWorkingStatus();
        //Assign department result data to departmentsData
        result.data.forEach(element => {
          let filterData = this.jobDetailForm
            .get('department')
            ['controls'][0].controls.sub_department.value.filter(function (item) {
              return item.department_id == element.id && item.is_main_job == 1;
            });
          if (filterData) {
            if (filterData.length > 0) {
              element.is_main_job = 1;
            }
          } else {
            element.is_main_job = 0;
          }

          let setChecked = this.jobDetailForm
            .get('department')
            ['controls'][0].controls.sub_department.value.filter(function (item) {
              return item.department_id == element.id;
            });
          if (setChecked) {
            if (setChecked.length > 0) {
              element.is_checked = 1;
            }
          } else {
            element.is_checked = 0;
          }
        });
        this.departmentsData = result.data.filter(function (item) {
          return item.status == 1 && item.is_hidden == 0;
        });
        this.pageLoaded = true;
        this.detailDataLoaded = true;
        setTimeout(() => {
          this.hidden1.nativeElement.focus();
          // this.owner_id.nativeElement.focus();
          this.loadAutoFocus('#owner_id', true);

          if (this.jobDetailForm.get('labor_per_diem').value == 1) {
            this.setDisableStates(true, 'labor_per_diem');
            this.disbleTabPerDiem = true;
          } else {
            this.setDisableStates(false, 'labor_per_diem');
            this.disbleTabPerDiem = false;
          }
          if (this.jobDetailForm.get('additional_union_targeting').value == 1) {
            this.disableTabUnionTargeting = true;
            this.setDisableStates(true, 'additional_union_targeting');
          } else {
            this.disableTabUnionTargeting = false;
            this.setDisableStates(false, 'additional_union_targeting');
          }
          if (this.jobDetailForm.get('additional_bond_required').value == 1) {
            this.enableTabRequired(true);
          } else {
            this.enableTabRequired(false);
          }
          if (this.jobDetailForm.get('additional_insurance_cert_required').value == 1) {
            this.enableInsuranceRequired(true);
          } else {
            this.enableInsuranceRequired(false);
          }
          setTimeout(() => {
            this.loadDatePicker();
          }, 1500);
        }, 200);
      }
    }
  }

  //On error of departments api call
  onDepartmentsError(error) {
    this.pageLoaded = true;
  }

  //To get all users
  getUsers() {
    //Service call to get all users data
    this.usersService.getUsers().subscribe(
      res => this.onUsersSuccess(res),
      error => this.onUsersError(error),
    );
  }

  //On success of users api call
  onUsersSuccess(result) {
    if (result) {
      if (result.data) {
        //Assign users result data to projectManagerData, projectForemanData and ProjectAssistantData
        this.projectManagerData = result.data.filter(function (item) {
          return (item.role_id == 4 || item.role_id == 14) && item.status == 1;
        });
        this.ProjectAssistantData = result.data.filter(function (item) {
          return item.role_id == 7 && item.status == 1;
        });
        this.projectForemanData = result.data.filter(function (item) {
          return (item.role_id == 3 || item.role_id == 6 || item.role_id == 12) && item.status == 1;
        });

        // Intentional to add additional foreman dropdown options.
        const noFM = { id: 999999999, employee_alias: 'NO Foreman' };

        this.projectForemanData = [noFM].concat(this.projectForemanData);

        this.projectEstimatorData = result.data.filter(function (item) {
          return (item.role_id == 4 || item.role_id == 14) && item.status == 1;
        });
      }
    }
  }

  //On error of departments api call
  onUsersError(error) {}

  //To get all owners
  getOwners() {
    //Service call to get all owners data
    this.ownerInfoService.getOwners().subscribe(
      res => this.onOwnersSuccess(res),
      error => this.onOwnersError(error),
    );
  }

  //On success of owners api call
  onOwnersSuccess(result) {
    if (!result?.data) return;

    this.ownersData = result.data;
  }

  //On error of owners api call
  onOwnersError(error) {}

  //To get all working status
  getWorkingStatus() {
    //Service call to get all working status data
    this.workingStatusService.getWorkingStatus().subscribe(
      res => this.onWorkingStatusSuccess(res),
      error => this.onWorkingStatusError(error),
    );
  }

  //On success of working status api call
  onWorkingStatusSuccess(result) {
    if (!result?.data) return;

    this.workingStatusData = result.data;
  }

  //On error of working wtatus api call
  onWorkingStatusError(error) {}

  //To get all working status
  getBillingDueDateTypes() {
    //Service call to get all working status data
    this.billingDueDateTypesService.getWorkingStatus().subscribe(
      res => this.onBillingDueDateTypesSuccess(res),
      error => this.onBillingDueDateTypesError(error),
    );
  }

  //On success of working status api call
  onBillingDueDateTypesSuccess(result) {
    if (result?.data) {
      this.billingDueDateTypesData = result.data;
    }
  }

  //On error of working wtatus api call
  onBillingDueDateTypesError(error) {}

  getWorkingStatusText(id) {
    if (this.jobDetail) {
      const workingStatusResult = this.workingStatusData.filter(function (item) {
        if (item.id == id) {
          return item;
        }
      });

      if (workingStatusResult.length > 0) {
        return workingStatusResult[0].name;
      } else {
        return 'Created';
      }
    }
  }

  //To get all project type
  getProjectType() {
    //Service call to get all ProjectType data
    this.projectTypeService.getProjectType().subscribe(
      res => this.onProjectTypeSuccess(res),
      error => this.onProjectTypeError(error),
    );
  }

  //On success of project type api call
  onProjectTypeSuccess(result) {
    if (result) {
      if (result.data) {
        this.projectTypeData = result.data;
      }
    }
  }

  //On error of project type api call
  onProjectTypeError(error) {}

  //To get all project industry
  getProjectIndustry() {
    //Service call to get all project industry data
    this.projectIndustryService.getProjectIndustry().subscribe(
      res => this.onProjectIndustrySuccess(res),
      error => this.onProjectIndustryError(error),
    );
  }

  //On success of project industry api call
  onProjectIndustrySuccess(result) {
    if (result) {
      if (result.data) {
        this.projectIndustryData = result.data;
      }
    }
  }

  //On error of project industry api call
  onProjectIndustryError(error) {}

  //To get all owners
  getTaxStatus() {
    //Service call to get all tax status data
    this.taxStatusService.getTaxStatus().subscribe(
      res => this.onTaxStatusSuccess(res),
      error => this.onTaxStatusError(error),
    );
  }

  //On success of tax status api call
  onTaxStatusSuccess(result) {
    if (result) {
      if (result.data) {
        this.taxStatusData = result.data;
      }
    }
  }

  //On error of tax status api call
  onTaxStatusError(error) {}

  disableFormGroupByRole() {
    setTimeout(() => {
      this.checkForPermission(this.userPermissions['general_info'], 'general_info');
      this.checkForPermission(this.userPermissions['billing_accounting'], 'billing_accounting');
      this.checkForPermission(this.userPermissions['financials'], 'financials');
      this.checkForPermission(this.userPermissions['audit_trail'], 'audit_trail');
      this.checkForPermission(this.userPermissions['working_status'], 'working_status');
    }, 1000);
  }

  checkForPermission(permission, val) {
    switch (val) {
      case 'general_info':
        this.disableGeneralInfoFormPermission(permission);
        break;

      case 'billing_accounting':
        this.disableBillingAccFormPermission(permission);
        break;

      case 'financials':
        this.disableFinanceFormPermission(permission);
        break;

      case 'audit_trail':
        this.disableAuditTrailPermission(permission);
        break;

      case 'working_status':
        this.disableWorkingStatusPermission(permission);
        break;

      default:
        break;
    }
  }

  disableGeneralInfoFormPermission(permission) {
    if (permission['view'] === 1 && permission['edit'] === 0) {
      this.permissionMap.general_info['view'] = 1;
      this.permissionMap.general_info['edit'] = 0;
      if (this.jobDetailForm) {
        this.jobDetailForm.get('owner_id').disable();
        this.jobDetailForm.get('facility_location_id').disable();
        this.jobDetailForm.get('project_type_id').disable();
        // this.jobDetailForm.get('project_industry_id').disable();
        this.jobDetailForm.get('department')['controls'][0].controls.sub_department.disable();
      }
      // this.jobDetailForm.get('department').disable();
    } else if (permission['view'] === 1 && permission['edit'] === 1) {
      // this.permissionMap.general_info = false;
      this.permissionMap.general_info['view'] = 1;
      this.permissionMap.general_info['edit'] = 1;
    }
  }

  disableBillingAccFormPermission(permission) {
    if (permission['view'] === 1 && permission['edit'] === 0) {
      this.permissionMap.billing_accounting['view'] = 1;
      this.permissionMap.billing_accounting['edit'] = 0;
      if (this.jobDetailForm) {
        this.jobDetailForm.get('contact_ar_customer_name_id').disable();
        this.jobDetailForm.get('contact_type_of_billing').disable();
        this.jobDetailForm.get('labor_union_local_id').disable();
        this.jobDetailForm.get('sales_tax_status_id').disable();
      }
    } else if (permission['view'] === 1 && permission['edit'] === 1) {
      this.permissionMap.billing_accounting['view'] = 1;
      this.permissionMap.billing_accounting['edit'] = 1;
    }
  }

  disableFinanceFormPermission(permission) {
    if (permission['view'] === 1 && permission['edit'] === 0) {
      this.permissionMap.financials['view'] = 1;
      this.permissionMap.financials['edit'] = 0;
    } else if (permission['view'] === 1 && permission['edit'] === 1) {
      this.permissionMap.financials['view'] = 1;
      this.permissionMap.financials['edit'] = 1;
    }
  }

  disableAuditTrailPermission(permission) {
    if (permission['view'] === 1 && permission['edit'] === 0) {
      this.permissionMap.audit_trail['view'] = 1;
      this.permissionMap.audit_trail['edit'] = 0;
    } else if (permission['view'] === 1 && permission['edit'] === 1) {
      this.permissionMap.audit_trail['view'] = 1;
      this.permissionMap.audit_trail['edit'] = 1;
    }
  }

  disableWorkingStatusPermission(permission) {
    if (permission['view'] == 1 && permission['edit'] == 0) {
      this.permissionMap.working_status['view'] = 1;
      this.permissionMap.working_status['edit'] = 0;
    } else if (permission['view'] == 1 && permission['edit'] == 1) {
      this.permissionMap.working_status['view'] = 1;
      this.permissionMap.working_status['edit'] = 1;
    }
  }

  //To load selected facility id
  loadSelectedOwnerFacility(id) {
    this.initGeneral = false;
    this.jobDetailForm.get('owner_id').setValue(id);
    if (this.lastOwner != id) {
      this.getOwnerInfo(id);
      this.lastOwner = id;
    }
    this.loadErrorStatus();
  }

  //To get specific owner data
  getOwnerInfo(id) {
    this.ownerInfoService.getOwnerFacilityInfoById(id).subscribe(
      res => this.onOwnerFacilitySuccess(res),
      error => this.onOwnerFacilityError(error),
    );
  }

  //On success of api call
  onOwnerFacilitySuccess(result) {
    if (result) {
      if (result.data) {
        this.ownersFacilityData = [];
        this.ownersFacilityData = result.data.facility;
        this.jobDetailForm.get('project_industry_id').setValue(result.data.project_industry_id);
        setTimeout(() => {
          this.triggerChange('#project_industry_id_select');
        }, 200);
        if (this.ownersFacilityData) {
          if (this.ownersFacilityData.length == 1) {
            this.jobDetailForm.get('facility_location_id').setValue(result.data.facility[0].id);
            this.setSelectedFacilityAddress(result.data.facility[0].id);
            setTimeout(() => {
              this.triggerChange('#facility_location_id');
            }, 200);
          }
        }
      }
    }
  }

  //On error of api call
  onOwnerFacilityError(error) {}

  //To set selected file
  onFileSelect(event, type) {
    if (event.target.files.length > 0) {
      const preview = document.querySelector('.preview');
      const file = event.target.files;
      this.jobDetailForm.get(type).setValue(file);

      if (event.target.files.length === 0) return;

      const curFiles = event.target.files;
      if (!curFiles.length) {
        const para = document.createElement('p');
        para.textContent = 'No files currently selected for upload';
        preview.appendChild(para);
      } else {
        const list = document.createElement('ol');
        preview.appendChild(list);

        for (const file of curFiles) {
          const listItem = document.createElement('li');
          const para = document.createElement('p');

          para.textContent = `${file.name}`;

          listItem.appendChild(para);

          list.appendChild(listItem);
        }
      }
    }
  }

  //To upload file
  uploadFiles() {
    this.fileUploadCloseBtn.nativeElement.click();
    this.startUpload();
  }

  submitToAccounting(form) {
    if (form.invalid) {
      this.jobDetailForm.markAllAsTouched();
      this.jobDetailForm.markAsDirty();
      this.loadErrorStatus();
      this.showSubmitToAccountingModal.nativeElement.click();
      this.isSubmitToAccounting = true;
    } else {
      this.saveJobDetails(form, false, true);
    }
  }

  //To save updated job details
  async saveJobDetails(form, close = false, submitToAccounting = false, submitToAccountingWithValidate = false) {
    try {
      this.isSubmitToAccounting = false;

      if (submitToAccounting && form.invalid && submitToAccountingWithValidate) {
        this.jobDetailForm.markAllAsTouched();
        this.loadErrorStatus();
        this.toastService.showToast('Please fill up all required field', 'warning');
        return;
      }

      this.loaderService.displayLoader();

      let waitRes = submitToAccounting || undefined;

      this.lockedFieldChanges = {};

      if (this.initialValue[0].working_status == 5 && form.value.working_status == 5) {
        let changeStatus = 0;

        if (form.value.name != this.initialValue[0].name) {
          if (!this.lockedFieldChanges['general_info']) {
            this.lockedFieldChanges['general_info'] = {};
          }
          this.lockedFieldChanges['general_info']['name'] = {};
          this.lockedFieldChanges['general_info']['name']['key'] = 'Name';
          this.lockedFieldChanges['general_info']['name']['value'] = form.value.name;
          changeStatus = 1;
        }
        if (form.value.owner_id != this.initialValue[0].owner_id) {
          if (!this.lockedFieldChanges['general_info']) {
            this.lockedFieldChanges['general_info'] = {};
          }
          this.lockedFieldChanges['general_info']['owner_id'] = {};
          this.lockedFieldChanges['general_info']['owner_id']['key'] = 'Owner';
          let ownerFilterData = this.ownersData.filter(function (item) {
            return item.id == form.value.owner_id;
          });
          this.lockedFieldChanges['general_info']['owner_id']['value'] =
            ownerFilterData.length > 0 ? ownerFilterData[0].owner_name : '';
          changeStatus = 1;
        }
        if (form.value.facility_location_id != this.initialValue[0].facility_location_id) {
          if (!this.lockedFieldChanges['general_info']) {
            this.lockedFieldChanges['general_info'] = {};
          }
          this.lockedFieldChanges['general_info']['facility_location_id'] = {};
          this.lockedFieldChanges['general_info']['facility_location_id']['key'] = 'Facility';
          let ownerFacilityFilterData = this.ownersFacilityData.filter(function (item) {
            return item.id == form.value.facility_location_id;
          });
          this.lockedFieldChanges['general_info']['facility_location_id']['value'] =
            ownerFacilityFilterData.length > 0 ? ownerFacilityFilterData[0].facility_name : '';
          changeStatus = 1;
        }
        if (form.value.description != this.initialValue[0].description) {
          if (!this.lockedFieldChanges['general_info']) {
            this.lockedFieldChanges['general_info'] = {};
          }
          this.lockedFieldChanges['general_info']['description'] = {};
          this.lockedFieldChanges['general_info']['description']['key'] = 'Description';
          this.lockedFieldChanges['general_info']['description']['value'] = form.value.description;
          changeStatus = 1;
        }
        if (form.value.address1 != this.initialValue[0].address1) {
          if (!this.lockedFieldChanges['general_info']) {
            this.lockedFieldChanges['general_info'] = {};
          }
          this.lockedFieldChanges['general_info']['address1'] = {};
          this.lockedFieldChanges['general_info']['address1']['key'] = 'Address';
          this.lockedFieldChanges['general_info']['address1']['value'] = form.value.address1;
          changeStatus = 1;
        }
        if (form.value.city != this.initialValue[0].city) {
          if (!this.lockedFieldChanges['general_info']) {
            this.lockedFieldChanges['general_info'] = {};
          }
          this.lockedFieldChanges['general_info']['city'] = {};
          this.lockedFieldChanges['general_info']['city']['key'] = 'City';
          this.lockedFieldChanges['general_info']['city']['value'] = form.value.city;
          changeStatus = 1;
        }
        if (form.value.state_id != this.initialValue[0].state_id) {
          if (!this.lockedFieldChanges['general_info']) {
            this.lockedFieldChanges['general_info'] = {};
          }
          this.lockedFieldChanges['general_info']['state_id'] = {};
          this.lockedFieldChanges['general_info']['state_id']['key'] = 'State';
          let stateFilterData = this.statesData.filter(function (item) {
            return item.id == form.value.state_id;
          });
          this.lockedFieldChanges['general_info']['state_id']['value'] =
            stateFilterData.length > 0 ? stateFilterData[0].abbreviation : '';
          changeStatus = 1;
        }
        if (form.value.contact_ar_customer_name_id != this.initialValue[0].contact_ar_customer_name_id) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['contact_ar_customer_name_id'] = {};
          this.lockedFieldChanges['billing_accounting']['contact_ar_customer_name_id']['key'] = 'AR Customer Name';
          let arCustomerFilterData = this.arCustomerData.filter(function (item) {
            return item.id == form.value.contact_ar_customer_name_id;
          });
          this.lockedFieldChanges['billing_accounting']['contact_ar_customer_name_id']['value'] =
            arCustomerFilterData.length > 0 ? arCustomerFilterData[0].name : '';
          changeStatus = 1;
        }
        if (form.value.contact_ar_customer_id != this.initialValue[0].contact_ar_customer_id) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['contact_ar_customer_id'] = {};
          this.lockedFieldChanges['billing_accounting']['contact_ar_customer_id']['key'] = 'AR Customer Id';
          let arCustomerFilterData = this.arCustomerData.filter(function (item) {
            return item.id == form.value.contact_ar_customer_id;
          });
          this.lockedFieldChanges['billing_accounting']['contact_ar_customer_id']['value'] =
            arCustomerFilterData.length > 0 ? arCustomerFilterData[0].customer_id : '';
          changeStatus = 1;
        }
        if (form.value.contact_address1 != this.initialValue[0].contact_address1) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['contact_address1'] = {};
          this.lockedFieldChanges['billing_accounting']['contact_address1']['key'] = 'Address';
          this.lockedFieldChanges['billing_accounting']['contact_address1']['value'] =
            form.value.contact_address1.replace(/(\r\n|\n|\r)/gm, '<br>');
          changeStatus = 1;
        }
        if (form.value.contact_purchse_order != this.initialValue[0].contact_purchse_order) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['contact_purchse_order'] = {};
          this.lockedFieldChanges['billing_accounting']['contact_purchse_order']['key'] =
            'Customer Contact/Purchase Order #';
          this.lockedFieldChanges['billing_accounting']['contact_purchse_order']['value'] =
            form.value.contact_purchse_order;
          changeStatus = 1;
        }
        if (form.value.contact_type_of_billing != this.initialValue[0].contact_type_of_billing) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['contact_type_of_billing'] = {};
          this.lockedFieldChanges['billing_accounting']['contact_type_of_billing']['key'] = 'Type of Billing';
          this.lockedFieldChanges['billing_accounting']['contact_type_of_billing']['value'] =
            form.value.contact_type_of_billing == 1
              ? 'Quick Bill'
              : form.value.contact_type_of_billing == 2
                ? 'Contract'
                : form.value.contact_type_of_billing == 3
                  ? 'Contract'
                  : 'AIA';
          changeStatus = 1;
        }
        if (form.value.contact_retainage_per != this.initialValue[0].contact_retainage_per) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['contact_retainage_per'] = {};
          this.lockedFieldChanges['billing_accounting']['contact_retainage_per']['key'] = 'Retainage %';
          this.lockedFieldChanges['billing_accounting']['contact_retainage_per']['value'] =
            form.value.contact_retainage_per;
          changeStatus = 1;
        }
        if (form.value.contact_billing_due_date_type != this.initialValue[0].contact_billing_due_date_type) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['contact_billing_due_date_type'] = {};
          this.lockedFieldChanges['billing_accounting']['contact_billing_due_date_type']['key'] =
            'Billing Due Date Type';
          this.lockedFieldChanges['billing_accounting']['contact_billing_due_date_type']['value'] =
            form.value.contact_billing_due_date_type;
          changeStatus = 1;
        }
        if (form.value.labor_union_local_id != this.initialValue[0].labor_union_local_id) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['labor_union_local_id'] = {};
          this.lockedFieldChanges['billing_accounting']['labor_union_local_id']['key'] = 'Union Local #';
          let laborUnionLocalFilterData = this.unionLocalsData.filter(function (item) {
            return item.id == form.value.labor_union_local_id;
          });
          this.lockedFieldChanges['billing_accounting']['labor_union_local_id']['value'] =
            laborUnionLocalFilterData.length > 0 ? laborUnionLocalFilterData[0].union_local_id : '';
          changeStatus = 1;
        }
        if (form.value.labor_union_notes != this.initialValue[0].labor_union_notes) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['labor_union_notes'] = {};
          this.lockedFieldChanges['billing_accounting']['labor_union_notes']['key'] = 'Labor Notes';
          this.lockedFieldChanges['billing_accounting']['labor_union_notes']['value'] = form.value.labor_union_notes;
          changeStatus = 1;
        }
        if (form.value.labor_per_diem != this.initialValue[0].labor_per_diem) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['labor_per_diem'] = {};
          this.lockedFieldChanges['billing_accounting']['labor_per_diem']['key'] = 'Per Diem';
          this.lockedFieldChanges['billing_accounting']['labor_per_diem']['value'] =
            form.value.labor_per_diem == 1 ? 'Yes' : 'No';
          changeStatus = 1;
        }
        if (
          form.value.labor_per_diem == 1 &&
          form.value.labor_per_diem_notes != this.initialValue[0].labor_per_diem_notes
        ) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['labor_per_diem_notes'] = {};
          this.lockedFieldChanges['billing_accounting']['labor_per_diem_notes']['key'] = 'Per Diem Notes';
          this.lockedFieldChanges['billing_accounting']['labor_per_diem_notes']['value'] =
            form.value.labor_per_diem_notes;
          changeStatus = 1;
        }
        if (form.value.additional_union_targeting != this.initialValue[0].additional_union_targeting) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['additional_union_targeting'] = {};
          this.lockedFieldChanges['billing_accounting']['additional_union_targeting']['key'] = 'Union Targeting';
          this.lockedFieldChanges['billing_accounting']['additional_union_targeting']['value'] =
            form.value.additional_union_targeting == 1 ? 'Yes' : 'No';
          changeStatus = 1;
        }
        let additional_date_contract_requested =
          this.initialValue[0].additional_date_contract_requested != null &&
          this.initialValue[0].additional_date_contract_requested != '' &&
          this.initialValue[0].additional_date_contract_requested != undefined
            ? this.momentService.getGeneralDateFormat(this.initialValue[0].additional_date_contract_requested)
            : null;
        if (
          form.value.additional_union_targeting == 1 &&
          form.value.additional_date_contract_requested != additional_date_contract_requested
        ) {
          if (!this.lockedFieldChanges['billing_accounting']) {
            this.lockedFieldChanges['billing_accounting'] = {};
          }
          this.lockedFieldChanges['billing_accounting']['additional_date_contract_requested'] = {};
          this.lockedFieldChanges['billing_accounting']['additional_date_contract_requested']['key'] =
            'Date Contract Requested';
          this.lockedFieldChanges['billing_accounting']['additional_date_contract_requested']['value'] =
            form.value.additional_date_contract_requested;
          changeStatus = 1;
        }

        if (form.value.notes !== this.initialValue[0].notes) {
          this.lockedFieldChanges['notes'] = form.value.notes ?? '';
        }

        this.jobDetailForm.get('department').value[0]['sub_department'].forEach(element => {
          if (!this.lockedFieldChanges['general_info']) {
            this.lockedFieldChanges['general_info'] = {};
          }
          if (!this.lockedFieldChanges['general_info']['department_list']) {
            this.lockedFieldChanges['general_info']['department_list'] = {};
            this.lockedFieldChanges['general_info']['department_list']['value'] = [];
          }
          let filterDepartmentData = this.initialValue.filter(function (item) {
            return item.department_id == element.department_id;
          });
          if (filterDepartmentData.length == 0) {
            this.lockedFieldChanges['general_info']['department_list']['value'].push(element.department_short_code);
            this.lockedFieldChanges['general_info']['department_list']['key'] = 'Department(s)';
            changeStatus = 1;
          }
          if (
            (element.is_main_job == 1 && filterDepartmentData.length == 0) ||
            (filterDepartmentData.length > 0 &&
              element.is_main_job != filterDepartmentData[0].is_main_job &&
              element.is_main_job == 1)
          ) {
            this.lockedFieldChanges['general_info']['is_main_job'] = {};
            this.lockedFieldChanges['general_info']['is_main_job']['key'] = 'Main Job';
            this.lockedFieldChanges['general_info']['is_main_job']['value'] =
              element.department_short_code + ' - ' + element.department_name;
            changeStatus = 1;
          }
          if (
            ((element.project_manager_id != null || element.project_manager_id != '') &&
              filterDepartmentData.length == 0) ||
            (filterDepartmentData.length > 0 &&
              filterDepartmentData[0].project_manager_id != '' &&
              filterDepartmentData[0].project_manager_id != undefined &&
              filterDepartmentData[0].project_manager_id != null &&
              element.project_manager_id != filterDepartmentData[0].project_manager_id)
          ) {
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.project_manager_id] =
              {};
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.project_manager_id][
              'key'
            ] = element.department_short_code + '-' + element.department_name + ' - Project Manager';
            let projectManagerFilterData = this.projectManagerData.filter(function (item) {
              return element.project_manager_id == item.id;
            });
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.project_manager_id][
              'value'
            ] =
              projectManagerFilterData.length > 0
                ? projectManagerFilterData[0].employee_alias != null &&
                  projectManagerFilterData[0].employee_alias != '' &&
                  projectManagerFilterData[0].employee_alias != undefined
                  ? projectManagerFilterData[0].employee_alias
                  : projectManagerFilterData[0].first_name + ' ' + projectManagerFilterData[0].last_name
                : '';
            changeStatus = 1;
          }
          if (
            ((element.assistant_id != null || element.assistant_id != 0) && filterDepartmentData.length == 0) ||
            (filterDepartmentData.length > 0 &&
              filterDepartmentData[0].assistant_id != undefined &&
              filterDepartmentData[0].assistant_id != null &&
              filterDepartmentData[0].assistant_id != '' &&
              element.assistant_id != filterDepartmentData[0].assistant_id)
          ) {
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.assistant_id] = {};
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.assistant_id]['key'] =
              element.department_short_code + '-' + element.department_name + ' - Project Assistant';
            let projectAssistantFilterData = this.ProjectAssistantData.filter(function (item) {
              return element.assistant_id == item.id;
            });
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.assistant_id][
              'value'
            ] =
              projectAssistantFilterData.length > 0
                ? projectAssistantFilterData[0].employee_alias != null &&
                  projectAssistantFilterData[0].employee_alias != '' &&
                  projectAssistantFilterData[0].employee_alias != undefined
                  ? projectAssistantFilterData[0].employee_alias
                  : projectAssistantFilterData[0].first_name + ' ' + projectAssistantFilterData[0].last_name
                : '';
            changeStatus = 1;
          }
          if (
            ((element.partner_assistant_id != null || element.partner_assistant_id != 0) &&
              filterDepartmentData.length == 0) ||
            (filterDepartmentData.length > 0 &&
              filterDepartmentData[0].partner_assistant_id != undefined &&
              filterDepartmentData[0].partner_assistant_id != null &&
              filterDepartmentData[0].partner_assistant_id != '' &&
              element.partner_assistant_id != filterDepartmentData[0].partner_assistant_id)
          ) {
            this.lockedFieldChanges['general_info'][
              element.department_short_code + ' ' + element.partner_assistant_id
            ] = {};
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.partner_assistant_id][
              'key'
            ] = element.department_short_code + '-' + element.department_name + ' - Partner Assistant';
            let projectAssistantFilterData = this.ProjectAssistantData.filter(function (item) {
              return element.partner_assistant_id == item.id;
            });
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.partner_assistant_id][
              'value'
            ] =
              projectAssistantFilterData.length > 0
                ? projectAssistantFilterData[0].employee_alias != null &&
                  projectAssistantFilterData[0].employee_alias != '' &&
                  projectAssistantFilterData[0].employee_alias != undefined
                  ? projectAssistantFilterData[0].employee_alias
                  : projectAssistantFilterData[0].first_name + ' ' + projectAssistantFilterData[0].last_name
                : '';
            changeStatus = 1;
          }
          if (
            ((element.partner_assistant_id != null || element.partner_assistant_id != 0) &&
              filterDepartmentData.length == 0) ||
            (filterDepartmentData.length > 0 &&
              filterDepartmentData[0].partner_assistant_id != undefined &&
              filterDepartmentData[0].partner_assistant_id != null &&
              filterDepartmentData[0].partner_assistant_id != '' &&
              element.partner_assistant_id != filterDepartmentData[0].partner_assistant_id)
          ) {
            this.lockedFieldChanges['general_info'][
              element.department_short_code + ' ' + element.partner_assistant_id
            ] = {};
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.partner_assistant_id][
              'key'
            ] = element.department_short_code + '-' + element.department_name + ' - Partner Assistant';
            let projectAssistantFilterData = this.ProjectAssistantData.filter(function (item) {
              return element.partner_assistant_id == item.id;
            });
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.partner_assistant_id][
              'value'
            ] =
              projectAssistantFilterData.length > 0
                ? projectAssistantFilterData[0].employee_alias != null &&
                  projectAssistantFilterData[0].employee_alias != '' &&
                  projectAssistantFilterData[0].employee_alias != undefined
                  ? projectAssistantFilterData[0].employee_alias
                  : projectAssistantFilterData[0].first_name + ' ' + projectAssistantFilterData[0].last_name
                : '';
            changeStatus = 1;
          }
          if (
            (element.foreman_id == 1 && filterDepartmentData.length == 0) ||
            (filterDepartmentData.length > 0 &&
              filterDepartmentData[0].foreman_id != undefined &&
              filterDepartmentData[0].foreman_id != null &&
              filterDepartmentData[0].foreman_id != '' &&
              element.foreman_id != filterDepartmentData[0].foreman_id) ||
            (filterDepartmentData.length > 0 && filterDepartmentData[0].foreman_id == 0 && element.foreman_id != 0)
          ) {
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.foreman_id] = {};
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.foreman_id]['key'] =
              element.department_short_code + '-' + element.department_name + ' - Project Foreman';
            let projectForemanFilterData = this.projectForemanData.filter(function (item) {
              return element.foreman_id == item.id;
            });
            this.lockedFieldChanges['general_info'][element.department_short_code + ' ' + element.foreman_id]['value'] =
              projectForemanFilterData.length > 0
                ? projectForemanFilterData[0].employee_alias != null &&
                  projectForemanFilterData[0].employee_alias != '' &&
                  projectForemanFilterData[0].employee_alias != undefined
                  ? projectForemanFilterData[0].employee_alias
                  : projectForemanFilterData[0].first_name + ' ' + projectForemanFilterData[0].last_name
                : '';
            changeStatus = 1;
          }
        });

        if (!this.lockedFieldChanges['general_info']?.department_list?.value?.length) {
          delete this.lockedFieldChanges['general_info']['department_list'];
        }

        if (this.lockedFieldChanges['general_info'] && !Object.keys(this.lockedFieldChanges['general_info']).length) {
          delete this.lockedFieldChanges['general_info'];
        }

        if (
          this.lockedFieldChanges['billing_accounting'] &&
          !Object.keys(this.lockedFieldChanges['billing_accounting']).length
        ) {
          delete this.lockedFieldChanges['billing_accounting'];
        }

        // foreman_id
        if (this.lockedFieldChanges['foreman_id'] && !Object.keys(this.lockedFieldChanges['foreman_id']).length) {
          delete this.lockedFieldChanges['foreman_id'];
        }

        // Audit Trail will say "The locked fields were updated in General Info and B&A tab"
        if (changeStatus) {
          const status_to_data = form.value.status;
          const newAuditTrail = {
            job_id: this.jobId,
            user_id: this.userId,
            ip_address: this.ipAddress,
            action: 0,
            status_from: status_to_data,
            status_to: 7,
            working_status_from: 0,
            working_status_to: 0,
            created_date: this.momentService.getDBDateTimeFormat(),
          };

          this.createJobAuditTrail(newAuditTrail);
        }
      }

      if (
        (!form?.pristine && form?.touched) ||
        form.dirty ||
        this.markDirty ||
        this.jobDepartmentCustomCostCodeDetailForm.dirty ||
        this.jobDetailForm.get('department').dirty
      ) {
        const newAuditTrail = {
          job_id: this.jobId,
          user_id: this.userId,
          ip_address: this.ipAddress,
          action: 0,
          status_from: 0,
          status_to: 6,
          working_status_from: 0,
          working_status_to: 0,
          created_date: this.momentService.getDBDateTimeFormat(),
        };

        this.createJobAuditTrail(newAuditTrail);
      }

      if (!submitToAccounting || (submitToAccounting && waitRes)) {
        const jobDataArr = {};

        if (submitToAccounting) {
          jobDataArr['contract_total'] = this.grandContractTotal;
          jobDataArr['estimated_cost'] = this.grandEstimatedCost;
        }

        this.permitTypesData = this.jobDetailForm.get('permit_type').value[0]['indi_permittype'];

        delete this.jobDetail.department_id;
        delete this.jobDetail.is_main_job;
        delete this.jobDetail.project_manager_id;
        delete this.jobDetail.assistant_id;
        delete this.jobDetail.partner_assistant_id;
        delete this.jobDetail.foreman_id;
        delete this.jobDetail.estimator_id;
        delete this.jobDetail.notes;
        delete this.jobDetail.department_name;
        delete this.jobDetail.department_short_code;
        delete this.jobDetail.project_manager_name;
        delete this.jobDetail.project_assistant_name;
        delete this.jobDetail.partner_assistant_name;
        delete this.jobDetail.project_foreman_name;
        delete this.jobDetail.submitted_by_name;

        jobDataArr['locked_field_changes'] = this.lockedFieldChanges;
        delete this.jobDetailForm.value.job_creation_date;

        if (
          this.jobDetailForm.get('start_date').value != null &&
          this.jobDetailForm.get('start_date').value != '' &&
          this.jobDetailForm.get('start_date').value != undefined
        ) {
          this.jobDetailForm
            .get('start_date')
            .setValue(this.momentService.getDBDateFormat(this.jobDetailForm.get('start_date').value));
        } else {
          this.jobDetailForm.get('start_date').setValue(null);
        }
        if (
          this.jobDetailForm.get('end_date').value != null &&
          this.jobDetailForm.get('end_date').value != '' &&
          this.jobDetailForm.get('end_date').value != undefined
        ) {
          this.jobDetailForm
            .get('end_date')
            .setValue(this.momentService.getDBDateFormat(this.jobDetailForm.get('end_date').value));
        } else {
          this.jobDetailForm.get('end_date').setValue(null);
        }
        if (
          this.jobDetailForm.get('turnover_completion_date').value != null &&
          this.jobDetailForm.get('turnover_completion_date').value != '' &&
          this.jobDetailForm.get('turnover_completion_date').value != undefined
        ) {
          this.jobDetailForm
            .get('turnover_completion_date')
            .setValue(this.momentService.getDBDateFormat(this.jobDetailForm.get('turnover_completion_date').value));
        } else {
          this.jobDetailForm.get('turnover_completion_date').setValue(null);
        }

        if (
          this.jobDetailForm.get('additional_date_contract_requested').value != null &&
          this.jobDetailForm.get('additional_date_contract_requested').value != '' &&
          this.jobDetailForm.get('additional_date_contract_requested').value != undefined
        ) {
          this.jobDetailForm
            .get('additional_date_contract_requested')
            .setValue(
              this.momentService.getDBDateFormat(this.jobDetailForm.get('additional_date_contract_requested').value),
            );
        } else {
          this.jobDetailForm.get('additional_date_contract_requested').setValue(null);
        }
        if (
          this.jobDetailForm.get('additional_bond_received_date').value != null &&
          this.jobDetailForm.get('additional_bond_received_date').value != '' &&
          this.jobDetailForm.get('additional_bond_received_date').value != undefined
        ) {
          this.jobDetailForm
            .get('additional_bond_received_date')
            .setValue(
              this.momentService.getDBDateFormat(this.jobDetailForm.get('additional_bond_received_date').value),
            );
        } else {
          this.jobDetailForm.get('additional_bond_received_date').setValue(null);
        }
        if (
          this.jobDetailForm.get('additional_bond_signed_date').value != null &&
          this.jobDetailForm.get('additional_bond_signed_date').value != '' &&
          this.jobDetailForm.get('additional_bond_signed_date').value != undefined
        ) {
          this.jobDetailForm
            .get('additional_bond_signed_date')
            .setValue(this.momentService.getDBDateFormat(this.jobDetailForm.get('additional_bond_signed_date').value));
        } else {
          this.jobDetailForm.get('additional_bond_signed_date').setValue(null);
        }
        if (
          this.jobDetailForm.get('additional_bond_sent_date').value != null &&
          this.jobDetailForm.get('additional_bond_sent_date').value != '' &&
          this.jobDetailForm.get('additional_bond_sent_date').value != undefined
        ) {
          this.jobDetailForm
            .get('additional_bond_sent_date')
            .setValue(this.momentService.getDBDateFormat(this.jobDetailForm.get('additional_bond_sent_date').value));
        } else {
          this.jobDetailForm.get('additional_bond_sent_date').setValue(null);
        }
        if (
          this.jobDetailForm.get('additional_insurance_cert_received_date').value != null &&
          this.jobDetailForm.get('additional_insurance_cert_received_date').value != '' &&
          this.jobDetailForm.get('additional_insurance_cert_received_date').value != undefined
        ) {
          this.jobDetailForm
            .get('additional_insurance_cert_received_date')
            .setValue(
              this.momentService.getDBDateFormat(
                this.jobDetailForm.get('additional_insurance_cert_received_date').value,
              ),
            );
        } else {
          this.jobDetailForm.get('additional_insurance_cert_received_date').setValue(null);
        }
        if (
          this.jobDetailForm.get('additional_insurance_cert_sent_date').value != null &&
          this.jobDetailForm.get('additional_insurance_cert_sent_date').value != '' &&
          this.jobDetailForm.get('additional_insurance_cert_sent_date').value != undefined
        ) {
          this.jobDetailForm
            .get('additional_insurance_cert_sent_date')
            .setValue(
              this.momentService.getDBDateFormat(this.jobDetailForm.get('additional_insurance_cert_sent_date').value),
            );
        } else {
          this.jobDetailForm.get('additional_insurance_cert_sent_date').setValue(null);
        }

        jobDataArr['job_details'] = this.jobDetailForm.get('department').value[0]['sub_department'];
        this.jobDepartmentFormData = this.jobDetailForm.get('department').value[0]['sub_department'];

        this.jobDetailForm.removeControl('submitted_by_name');
        this.jobDetailForm.removeControl('department');
        this.jobDetailForm.removeControl('permit_type');

        const filesObj = [
          'labor_attach_schedule',
          'sales_tax_attach_exemption_certificate',
          'additional_per_diem_documents',
          'additional_attach_targeting_contact',
          'contract_attach_project_purchase_order',
          'financial_attach_other_document',
          'labor_attach_schedule_filenames',
          'sales_tax_attach_exemption_certificate_filenames',
          'additional_per_diem_documents_filenames',
          'additional_attach_targeting_contact_filenames',
          'contract_attach_project_purchase_order_filenames',
          'financial_attach_other_document_filenames',
        ];

        filesObj.forEach(element => {
          if (this.fileList[element]) {
            form.value[element] = this.fileList[element].join(',');
            this.jobDetailForm.get(element).setValue(this.fileList[element].join(','));
          }
        });

        jobDataArr['job'] = this.jobDetailForm.value;

        if (submitToAccounting) {
          jobDataArr['job']['submit_to_accounting'] = 1;
        }

        jobDataArr['remove_jobs'] = this.deleteDepartmentIds;

        this.jobsService.updateJobById(this.jobId, jobDataArr).subscribe(
          res => this.onJobUpdateSuccess(res, submitToAccounting),
          error => this.onJobUpdateError(error),
        );

        if (close) {
          this.loaderService.hideLoader();
          this.router.navigateByUrl('/jobs');
        }
      }
    } catch (error) {
      console.error('SAVE JOB DETAILS ERROR:', error);
      this.loaderService.hideLoader();
    }
  }

  getJobResponseMessage(result: any, submitToAccounting: boolean) {
    if (submitToAccounting && !!result?.errors?.length) {
      return [`${result.errors[0]}. Please try again.`, 'error'];
    }
    if (submitToAccounting) {
      return ['Job submitted to Accounting successfully.', 'success'];
    }
    if (!!result?.errors?.length) {
      return ['Job failed to save. Please try again.', 'error'];
    }

    return ['Job saved successfully.', 'success'];
  }

  //On success of job update api call
  async onJobUpdateSuccess(result: any, submitToAccounting: boolean) {
    if (!result?.data) return;

    // CRITICAL: Capture old working status BEFORE updating it
    const previousWorkingStatus = this.oldWorkingStatus;

    // Preserve job detail rows for form recreation (Promise.all mutates jobDepartmentFormData)
    const savedJobDetailsForForm = this.jobDepartmentFormData.map(el => ({ ...el }));

    let count = 0;
    this.isSubmitToAccounting = submitToAccounting;

    await Promise.all(
      this.jobDepartmentFormData.map(
        async element =>
          new Promise((resolve, reject) => {
            delete element.department_name;
            delete element.number;
            delete element.department_short_code;

            count = count + 1;

            if (this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + element.department_id)) {
              this.jobsService.getJobDepartment(this.jobId, element.department_id).subscribe(res => {
                if (res?.data?.length > 0) {
                  const departmentCostCodeDataArr = this.jobDepartmentCostCodeDetailForm.get(
                    'jobDepartmentCostCode_' + element.department_id,
                  )['controls'][0].controls.indi_costcode.value;

                  if (departmentCostCodeDataArr.length > 0) {
                    departmentCostCodeDataArr.forEach(element => {
                      element.potential_job_id = res.data[0].id;

                      // if these props are falsy, set to null
                      element.estimated_cost = element.estimated_cost || null;
                      element.estimated_hours = element.estimated_hours || null;
                      element.prod_units = element.prod_units || null;
                    });

                    this.potentialJobCostCodesService
                      .addUpatePotentialJobCostCode(departmentCostCodeDataArr)
                      .toPromise()
                      .then(() => resolve(true))
                      .catch(error => {
                        console.error(error);
                        reject(false);
                      });
                  } else {
                    resolve(true);
                  }
                }
              });
            }
          }),
      ),
    );

    if (this.jobDepartmentFormData.length === count) {
      const [messageText, messageType] = this.getJobResponseMessage(result, submitToAccounting);

      this.toastService.showToast(messageText, messageType);

      // Use the returned job data instead of refetching
      if (result.data.job) {
        const jobData = result.data.job[0];

        // Update local state with the returned data
        this.jobDetail = jobData;
        this.working_status_data = jobData.working_status;
        this.oldWorkingStatus = jobData.working_status;

        const contacts = this.getContacts(jobData?.billing_contacts);
        if (!this.billingContacts?.length) {
          this.billingContacts = contacts;
        }

        // Use saved job detail rows so Job Contract & Cost Breakdown keeps all rows (e.g. second row)
        this.jobDepartmentData = savedJobDetailsForForm;
        this.initialValue = savedJobDetailsForForm;

        // Recreate the form with updated data FIRST
        this.createJobDetailForm(jobData);

        this.jobDetailForm.get('working_status').setValue(jobData.working_status);

        // Destroy Select2 if it exists, set the value, then reinitialize
        setTimeout(() => {
          const destroyScript = this.renderer2.createElement('script');
          destroyScript.type = 'text/javascript';
          destroyScript.text =
            `
            if ($('#working_status').hasClass('select2-hidden-accessible')) {
              $('#working_status').select2('destroy');
            }
            $('#working_status').val('` +
            jobData.working_status +
            `');
          `;
          this.renderer2.appendChild(this._document.body, destroyScript);

          // Reinitialize Select2
          setTimeout(() => {
            this.loadSelect2('.workingStatus', true);
          }, 50);
        }, 50);

        if (this.jobDetail['working_status'] == 5) {
          this.isActiveWorkingStatus = true;
        } else {
          this.isActiveWorkingStatus = false;
          if (this.jobDetail['status'] != 0) {
            this.activateLockedFields();
          }
        }

        // Handle deleted status
        if (this.jobDetail['status'] == 0) {
          this.loadSelect2('.aditionalSelect2', false);
        } else {
          this.loadSelect2('.aditionalSelect2', true);
        }

        this.checkTabEditPermission('general_info');

        // Refresh cost codes and audit trail
        this.getJobDepartmentCostCode();
        this.getCustomCostCodeData();
        this.getJobAuditTrail();

        // Handle preferred billing contact
        const preferredIndex = jobData?.billing_contacts_preferred_index ?? 0;
        const preferredContact = contacts[preferredIndex] || {
          contactName: '',
          contactEmail: '',
          billingEmail: '',
          phoneNumber: '',
          billingNote: '',
        };

        const selectedContact = {
          contactName: preferredContact.contactName,
          contactEmail: jobData.additional_contact_email || preferredContact.contactEmail,
          billingEmail: jobData.additional_portal_website_address || preferredContact.billingEmail,
          phoneNumber: jobData.additional_contact_phone_number || preferredContact.phoneNumber,
          billingNote: jobData.additional_portal_notes || preferredContact.billingNote,
        };

        this.jobDetailForm.get('additional_billing_contact_name').setValue(selectedContact.contactName);
        this.jobDetailForm.get('additional_contact_email').setValue(selectedContact.contactEmail);
        this.jobDetailForm.get('additional_contact_phone_number').setValue(selectedContact.phoneNumber);
        this.jobDetailForm.get('additional_portal_website_address').setValue(selectedContact.billingEmail);
        this.jobDetailForm.get('additional_portal_notes').setValue(selectedContact.billingNote);

        // Re-initialize UI elements
        setTimeout(() => {
          this.loadDatePicker();
          this.loadScroller();
        }, 500);

        this.markDirty = false;
      } else {
        // Fallback: if backend doesn't return job data yet, use the old method
        this.getJobDetails();
      }
    }

    if (this.jobDepartmentFormData) {
      let status_from_data = 0,
        status_to_data = 0;

      // Use the captured previousWorkingStatus instead of this.oldWorkingStatus
      if (this.jobDetailForm.get('working_status').value != previousWorkingStatus) {
        status_from_data = previousWorkingStatus;
        status_to_data = this.jobDetailForm.get('working_status').value;

        const newAuditTrail = {
          job_id: this.jobId,
          user_id: this.userId,
          ip_address: this.ipAddress,
          action: 2,
          status_from: 0,
          status_to: 0,
          working_status_from: status_from_data,
          working_status_to: status_to_data,
          created_date: this.momentService.getDBDateTimeFormat(),
        };

        this.createJobAuditTrail(newAuditTrail);
      }

      if (submitToAccounting) {
        status_from_data = previousWorkingStatus;
        status_to_data = 0;

        const newAuditTrail = {
          job_id: this.jobId,
          user_id: this.userId,
          ip_address: this.ipAddress,
          action: 2,
          status_from: 0,
          status_to: 0,
          working_status_from: status_from_data,
          working_status_to: status_to_data,
          created_date: this.momentService.getDBDateTimeFormat(),
        };

        this.createJobAuditTrail(newAuditTrail);
      }
    }

    this.loaderService.hideLoader();
  }

  //On error of job update api call
  onJobUpdateError(error) {}

  async addPermitType(element) {
    return new Promise((resolve, reject) => {
      element.record_date =
        element.record_date != null && element.record_date != '' && element.record_date != undefined
          ? this.momentService.getDBDateFormat(element.record_date)
          : null;
      if (element.id && element.id != '' && element.id != null && element.id != undefined) {
        this.jobPermitTypeService.updateJobById(element.id, element).subscribe(
          res => {
            if (res.data) resolve(res);
          },
          error => {
            if (error) reject(false);
          },
        );
      } else {
        this.jobPermitTypeService.createJobPermitType(element).subscribe(
          res => {
            if (res.data) resolve(res);
          },
          error => {
            if (error) reject(false);
          },
        );
      }
    });
  }

  addUpdateCostCode() {
    this.jobDetailForm.get('department').value[0]['sub_department'].forEach((element, index) => {
      setTimeout(() => {
        if (this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + element.department_id)) {
          this.jobsService.getJobDepartment(this.jobId, element.department_id).subscribe(res => {
            if (!!res?.data?.length) {
              const departmentCostCodeDataArr = this.jobDepartmentCostCodeDetailForm.get(
                'jobDepartmentCostCode_' + element.department_id,
              )['controls'][0].controls.indi_costcode.value;

              if (!!departmentCostCodeDataArr.length) {
                departmentCostCodeDataArr.forEach(element => {
                  element.potential_job_id = res.data[0].id;
                });
                this.potentialJobCostCodesService.addUpatePotentialJobCostCode(departmentCostCodeDataArr).subscribe(
                  res => console.log(res),
                  error => console.error(error),
                );
              }
            }
          });
        }
      }, 500);
    });
  }

  sortByKey(array, key, type = 'asc') {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      if (type == 'asc') {
        return x < y ? -1 : x > y ? 1 : 0;
      } else {
        return x > y ? -1 : x < y ? 1 : 0;
      }
    });
  }

  //To get all states data
  getStates() {
    this.statesServices.getStates().subscribe(
      res => this.onStatesSuccess(res),
      error => this.onStatesError(error),
    );
  }

  //On success of states api call
  onStatesSuccess(result) {
    if (result?.data) {
      this.statesData = result.data;
    }
  }

  //On error of states api call
  onStatesError(error) {}

  //To get all arcustomer data
  getARCustomer() {
    this.jobsService.getARCustomer().subscribe(
      res => this.onARCustomerSuccess(res),
      error => this.onARCustomerError(error),
    );
  }

  //On success of arcustomer api call
  onARCustomerSuccess(result) {
    if (result?.data) {
      this.arCustomerData = result.data;
    }
  }

  //On error of arcustomer api call
  onARCustomerError(error) {}

  //To get all union local data
  getUnionLocals() {
    this.jobsService.getUnionLocals().subscribe(
      res => this.onUnionLocalsSuccess(res),
      error => this.onUnionLocalsError(error),
    );
  }

  //On success of union locals api call
  onUnionLocalsSuccess(result) {
    if (result?.data) {
      this.unionLocalsData = result.data;
      this.unionLocalsData = this.unionLocalsData.filter(item => item.status == 1);
    }
  }

  //On error of union locals api call
  onUnionLocalsError(error) {}

  //To add/remove department detail section based on check/uncheck department
  addRemoveDepartment(event, changeDepartment) {
    let existDepartment = this.jobDepartmentData.filter(function (item) {
      return item.department_id == changeDepartment.id;
    });
    if (event.target.checked) {
      this.selectedDepartment = changeDepartment;
      if (existDepartment.length > 0) {
        this.addAdditionalInfoSameEditTime(
          this.jobDetailForm.get('department')['controls'][0].controls.sub_department,
          existDepartment[0],
        );
      } else {
        this.addAdditionalInfoSameEditTime(this.jobDetailForm.get('department')['controls'][0].controls.sub_department);
      }
      if (this.jobDetailForm.get('department')['controls'][0].controls.sub_department) {
        if (this.jobDetailForm.get('department')['controls'][0].controls.sub_department.value.length == 1) {
          this.jobDetailForm
            .get('department')
            ['controls'][0].controls.sub_department['controls'][0].get('is_main_job')
            .setValue(1);
        }
      }
      this.deleteDepartmentIds.forEach((item, index) => {
        if (item == changeDepartment.id) this.deleteDepartmentIds.splice(index, 1);
      });
      this.markDirty = true;
      this.jobDetailForm.get('department').markAsDirty();
    } else {
      this.clickedInlineCheckbox = changeDepartment.id;
      if (this.jobDetailForm.get('department')['controls'][0].controls.sub_department.value.length == 1) {
        this.removeDepartmentAlert.nativeElement.click();
      } else {
        this.deleteDepartmentModal.nativeElement.click();
      }
      let removeIndex;

      this.jobDetailForm.get('department')['controls'][0].controls.sub_department.value.forEach((element, index) => {
        if (element.department_id == changeDepartment.id) {
          this.mainJobId = element.is_main_job ? element.department_id : '';
          removeIndex = index;
          if (element.id != '') {
            this.deleteDepartmentId = element.department_id;
          }
        }
      });
      this.jobDetailForm.get('department')['controls'][0].controls.sub_department.removeAt(removeIndex);
    }
  }

  setDisableStates(value, field = null) {
    if (field != '' && field != null) {
      if (field == 'labor_per_diem') {
        this.disbleTabPerDiem = value;
      } else if (field == 'additional_union_targeting') {
        this.disableTabUnionTargeting = value;
      }
      this.jobDetailForm.get(field).setValue(value == true ? 1 : 0);
    } else {
      this.disableBakcupFields = value;
    }
    setTimeout(() => {
      this.setNextElementFocus();
    }, 200);
  }

  enableTabRequired(value) {
    this.enableTabBondRequired = value;
    setTimeout(() => {
      this.loadDatePicker();
      this.setNextElementFocus();
    }, 50);
  }

  enableInsuranceRequired(value) {
    this.enableTabInsuranceRequired = value;
    setTimeout(() => {
      this.loadDatePicker();
      this.setNextElementFocus();
    }, 50);
  }

  changeIsMainJob(selectedMainDepartmentValue) {
    let exist = false;

    this.jobDetailForm.get('department')['controls'][0].controls.sub_department.value.forEach((element, index) => {
      if (element.department_id == selectedMainDepartmentValue) {
        exist = true;
      }
    });
    if (!exist) {
      if (
        selectedMainDepartmentValue != null &&
        selectedMainDepartmentValue != undefined &&
        selectedMainDepartmentValue != ''
      ) {
        document.getElementById('inlineCheckbox' + selectedMainDepartmentValue).click();
      }
    }
    setTimeout(() => {
      this.jobDetailForm.get('department')['controls'][0].controls.sub_department.value.forEach((element, index) => {
        if (element.department_id == selectedMainDepartmentValue) {
          this.jobDetailForm
            .get('department')
            ['controls'][0].controls.sub_department['controls'][index].get('is_main_job')
            .setValue(1);
        } else {
          this.jobDetailForm
            .get('department')
            ['controls'][0].controls.sub_department['controls'][index].get('is_main_job')
            .setValue(0);
        }
      });
      this.getDepartments();
    }, 200);
  }

  //To get all permit type data
  getJobPermitType() {
    this.jobPermitTypeService.getJobPermitType(this.jobId).subscribe(
      res => this.onJobPermitTypesSuccess(res),
      error => this.onJobPermitTypesError(error),
    );
  }

  //On success of permit type api call
  onJobPermitTypesSuccess(result) {
    if (!result?.data) return;

    this.permitTypesData = result.data;
  }

  //On error of permit type api call
  onJobPermitTypesError(error) {}

  //To delete permit type
  deletePermitType(permitType, id = '', index) {
    if (id != '') {
      this.jobPermitTypeService.deleteJobPermitType(id).subscribe(
        res => console.log(res),
        error => console.error(error),
      );
      this.getJobPermitType();
      permitType.controls.indi_permittype.removeAt(index);
      this.markDirty = true;
      this.jobDetailForm.get('permit_type').markAsDirty;
    } else {
      permitType.controls.indi_permittype.removeAt(index);
    }
  }

  getInvoiceDescriptions() {
    this.invoicesService.getStatusTypes().subscribe(response => {
      if (response?.data) {
        this.invoiceStatusData = response.data;

        for (const status of this.invoiceStatusData) {
          this.invoiceStatusDescription[`${status.id}`] = status.name;
        }
      }
    });
  }

  triggerChange(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `triggerChange('` + obj + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To set job address based on facility selected
  setSelectedFacilityAddress(facilityId) {
    this.jobDetailForm.get('facility_location_id').setValue(facilityId);
    if (facilityId != '') {
      let addressData = this.ownersFacilityData.filter(function (item) {
        return item.id == facilityId;
      })[0];
      if (addressData) {
        this.jobDetailForm.get('address1').setValue(addressData.street_address);
        this.jobDetailForm.get('address2').setValue(addressData.apartment);
        this.jobDetailForm.get('city').setValue(addressData.city);
        this.jobDetailForm.get('state_id').setValue(addressData.state);
        this.jobDetailForm.get('postal_code').setValue(addressData.zipcode);
        this.jobDetailForm.get('code').setValue(addressData.code);
        this.triggerChange('#state_id_select');
      }
    }
    this.loadErrorStatus();
  }

  //To remove department from database
  removeDepartment() {
    if (this.deleteDepartmentId != '') {
      this.deleteDepartmentIds.push(this.deleteDepartmentId);
      this.deleteDepartmentId = '';
    }
    this.confirmedRemove = true;
    this.departmentCloseBtn.nativeElement.click();
    this.markDirty = true;
    this.jobDetailForm.get('department').markAsDirty();
    this.setNewMainJob();
  }

  setNewMainJob() {
    let filterData = this.jobDetailForm
      .get('department')
      ['controls'][0].controls.sub_department.value.filter(function (item) {
        return item.is_main_job == 1;
      });
    if (filterData.length == 0) {
      let count = 0;
      this.departmentsData.forEach(depArr => {
        if (count < 1) {
          this.jobDetailForm
            .get('department')
            ['controls'][0].controls.sub_department.value.forEach((element1, index1) => {
              if (depArr.id == element1.department_id) {
                element1.is_main_job = 1;
                this.triggerChange('#mainDepartment');
                count++;
              }
            });
        }
      });
    }
  }

  //On success of delete job department
  onJobDepartmentDeleteSuccess(result) {
    this.departmentCloseBtn.nativeElement.click();
    if (result) {
      if (result.data) {
        this.toastService.showToast('Department deleted successfully', 'success');
      }
    }
  }

  //On error of delete job department
  onJobDepartmentDeleteError(error) {}

  //To redo selection from last checked department
  redoSelection() {
    if (!this.confirmedRemove) {
      document.getElementById('inlineCheckbox' + this.clickedInlineCheckbox).click();
    } else {
      this.jobDetailForm.get('department')['controls'][0].controls.sub_department.value.forEach((element, index) => {
        if (element.department_id == this.mainJobId) {
          this.jobDetailForm
            .get('department')
            ['controls'][0].controls.sub_department['controls'][index].get('is_main_job')
            .setValue(0);
        }
      });
      this.triggerChange('#mainDepartment');
      this.getDepartments();
    }
    this.confirmedRemove = false;
  }

  //To get all job audit trail
  getJobAuditTrail() {
    this.jobAuditTrailService.getJobAuditTrail(this.jobId).subscribe(
      res => this.onGetJobAuditTrailSuccess(res),
      error => this.onGetJobAuditTrailError(error),
    );
  }

  hasPermissions() {
    return this.userPermissions?.main_job_list?.edit && this.userPermissions?.general_info?.edit;
  }

  //On success of get job audit trail
  onGetJobAuditTrailSuccess(result) {
    if (!result?.data) return;

    this.clearDatatable();
    this.auditTrailData = result.data;
    const getLastSubmitToAccounting = result.data;
    if (getLastSubmitToAccounting.length > 0) {
      const latestSubmitToAccountingAuditTrail = getLastSubmitToAccounting.filter(function (item) {
        return (
          item.action == 2 &&
          item.working_status_to == 0 &&
          item.working_status_from !== 0 &&
          item.user_id != null &&
          item.user_id != 0 &&
          item.user_id != ''
        );
      });
      if (latestSubmitToAccountingAuditTrail.length > 0) {
        this.sortByKey(latestSubmitToAccountingAuditTrail, 'id', 'desc');
        this.lastSubmitToAccountingText = latestSubmitToAccountingAuditTrail[0].created_date;
      }
    }
    this.drawAuditTrailDatatable();
  }

  //On error of get job audit trail
  onGetJobAuditTrailError(error) {}

  //To get ip address of client
  getIP() {
    this.ipAddressService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  //To create job audit trail
  createJobAuditTrail(auditTrailArr) {
    this.jobAuditTrailService.createJobAuditTrail(auditTrailArr).subscribe(
      res => {
        // Refresh audit trail after successful creation
        this.getJobAuditTrail();
      },
      error => {
        console.error('Error creating audit trail:', error);
      },
    );
  }

  //To clear datatable
  clearDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearDatatable('.audit-trail-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To draw datatable with data
  drawAuditTrailDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `reloadDataTable('.audit-trail-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To get all job task code
  getJobDepartmentCostCode() {
    this.potentialJobCostCodesService.getPotentialJobCostCodes(this.jobId).subscribe(
      res => this.onGetJobDepartmentCostCodeSuccess(res),
      error => this.onGetJobDepartmentCostCodeError(error),
    );
  }

  //On success of get job task code
  onGetJobDepartmentCostCodeSuccess(result) {
    if (!result?.data) return;
    this.jobDepartmentCostCodeData = result.data;
    this.createDepartmentCostCodeDetailForm();
  }

  //On error of get job task code
  onGetJobDepartmentCostCodeError(error) {}

  //Create cost code form
  createDepartmentCostCodeDetailForm(data = null) {
    const newFormArr = [];
    this.jobDetailForm.get('department')['controls'][0].controls.sub_department.value.forEach((element, index) => {
      let newData = null;
      this.jobDepartmentTaskCodes[element.department_id] = [];
      if (this.jobDepartmentCostCodeData) {
        newData = this.jobDepartmentCostCodeData.filter(function (item) {
          return item.department_id == element.department_id;
        });
      }

      newFormArr['jobDepartmentCostCode_' + element.department_id] = this.formBuilder.array([
        this.addAdditionalCostCodeInfoRows(newData),
      ]);
    });

    this.jobDepartmentCostCodeDetailForm = this.formBuilder.group(newFormArr);
  }

  // Add additional data in cost code form
  addAdditionalCostCodeInfoRows(data = null) {
    /* Add new rows to existing dates */
    let group;
    group = this.formBuilder.group({
      indi_costcode: this.formBuilder.array([]),
    });

    //If data exist, set data in cost code form
    if (data != null) {
      data.forEach((element, index) => {
        this.addAdditionalCostCodeInfoSameEditTime(group.controls.indi_costcode, element);
      });
    } else {
      this.addAdditionalCostCodeInfoSameEditTime(group.controls.indi_costcode, data);
    }

    return group;
  }

  // Add form parameter in group
  addAdditionalCostCodeInfoSameEditTime(costcode: any, data = null) {
    /* Add new requests to existing dates */ //debugger
    let group;
    if (data != null) {
      //If data exist, set data in fields
      if (
        data.potential_job_default_cost_code_id != '' &&
        data.potential_job_default_cost_code_id != 0 &&
        data.potential_job_default_cost_code_id != null
      ) {
        group = this.formBuilder.group({
          id: [data.id],
          potential_job_id: [data.potential_job_id],
          department_id: [data.department_id],
          potential_job_default_cost_code_id: [data.potential_job_default_cost_code_id],
          potential_job_custom_cost_code_id: [data.potential_job_custom_cost_code_id],
          estimated_cost: [data.estimated_cost ? '$' + data.estimated_cost : null],
          estimated_hours: [data.estimated_hours],
          prod_units: [data.prod_units],
          pos1: [data.defaultPos1],
          pos2: [data.defaultPos2],
          pos3: [data.defaultPos3],
          pos4: [data.defaultPos4],
          description: [data.defaultDescription],
        });
      } else if (
        data.potential_job_custom_cost_code_id != '' &&
        data.potential_job_custom_cost_code_id != 0 &&
        data.potential_job_custom_cost_code_id != null
      ) {
        group = this.formBuilder.group({
          id: [data.id],
          potential_job_id: [data.potential_job_id],
          department_id: [data.department_id],
          potential_job_default_cost_code_id: [data.potential_job_default_cost_code_id],
          potential_job_custom_cost_code_id: [data.potential_job_custom_cost_code_id],
          estimated_cost: [data.estimated_cost ? '$' + data.estimated_cost : null],
          estimated_hours: [data.estimated_hours],
          prod_units: [data.prod_units],
          pos1: [data.customPos1.toUpperCase()],
          pos2: [data.customPos2.toUpperCase()],
          pos3: [data.customPos3.toUpperCase()],
          pos4: [data.customPos4.toUpperCase()],
          description: [data.customDescription],
        });
      }
      costcode.push(group);

      this.controlArryaSortByKey(costcode);
    } else {
    }
  }

  controlArryaSortByKey(array, type = 'asc') {
    return array.controls.sort(function (a, b) {
      var x1 = a.value['pos1'];
      var y1 = b.value['pos1'];
      var x2 = a.value['pos2'];
      var y2 = b.value['pos2'];
      var x3 = a.value['pos3'];
      var y3 = b.value['pos3'];
      var x4 = a.value['pos4'];
      var y4 = b.value['pos4'];
      if (type == 'asc') {
        if (x1 < y1) {
          return -1;
        } else {
          if (x1 > y1) {
            return 1;
          } else {
            if (x2 > y2) {
              return 1;
            } else {
              if (x2 < y2) {
                return -1;
              } else {
                if (x3 < y3) {
                  return -1;
                } else {
                  if (x3 > y3) {
                    return 1;
                  } else {
                    if (x4 < y4) {
                      return -1;
                    } else {
                      if (x4 > y4) {
                        return 1;
                      } else {
                        return 0;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return x1 < y1 ? -1 : x1 > y1 ? 1 : 0;
      } else {
        return x1 > y1 ? -1 : x1 < y1 ? 1 : 0;
      }
    });
  }

  //Create cost code form
  createDepartmentCustomCostCodeDetailForm(data = null) {
    let newFormArr = [];
    this.jobDetailForm.get('department')['controls'][0].controls.sub_department.value.forEach((element, index) => {
      let newData = null;
      this.jobDepartmentCustomCostCodes[element.department_id] = [];
      if (this.jobDepartmentCustomCostCodeData) {
        newData = this.jobDepartmentCustomCostCodeData.filter(function (item) {
          return item.department_id == element.department_id;
        });
      }

      if (newData.length > 0) {
        newFormArr['jobDepartmentCustomCostCode_' + element.department_id] = this.formBuilder.array([
          this.addAdditionalCustomCostCodeInfoRows(newData),
        ]);
      } else {
        newFormArr['jobDepartmentCustomCostCode_' + element.department_id] = this.formBuilder.array([
          this.addAdditionalCustomCostCodeInfoRows(null),
        ]);
      }
    });

    this.jobDepartmentCustomCostCodeDetailForm = this.formBuilder.group(newFormArr);
  }

  // Add additional data in cost code form
  addAdditionalCustomCostCodeInfoRows(data = null) {
    /* Add new rows to existing dates */
    let group;
    group = this.formBuilder.group({
      indi_costcode: this.formBuilder.array([]),
    });

    //If data exist, set data in cost code form
    if (data != null) {
      data.forEach(element => {
        this.addAdditionalCustomCostCodeInfoSameEditTime(group.controls.indi_costcode, element);
      });
    } else {
      this.addAdditionalCustomCostCodeInfoSameEditTime(group.controls.indi_costcode, data);
    }

    return group;
  }

  // Add form parameter in group
  addAdditionalCustomCostCodeInfoSameEditTime(costcode: any, data = null) {
    /* Add new requests to existing dates */ //debugger
    let group;

    if (data != null) {
      //If data exist, set data in fields
      group = this.formBuilder.group({
        id: [data.id],
        potential_job_id: [data.potential_job_id],
        pos1: [data.pos1.toUpperCase(), Validators.required],
        pos2: [data.pos2.toUpperCase(), Validators.required],
        pos3: [data.pos3.toUpperCase(), Validators.required],
        pos4: [data.pos4.toUpperCase(), Validators.required],
        description: [data.description, Validators.required],
        updated_date: this.momentService.getDBDateTimeFormat(),
      });

      costcode.push(group);
    } else {
      //To create new cost code in view
      group = this.formBuilder.group({
        potential_job_id: [this.lastPotentialJobId],
        pos1: [''],
        pos2: [''],
        pos3: [''],
        pos4: [''],
        description: [''],
        created_date: this.momentService.getDBDateTimeFormat(),
        updated_date: this.momentService.getDBDateTimeFormat(),
      });

      costcode.push(group);
    }
  }

  //To get cost code data
  getDefaultCostCodeData(departmentId, potentialJobId) {
    this.costCodesLoaded = false;
    this.jobDefaultCostCodeData = [];
    this.lastJobCostCodeDeparrmentSelection = departmentId;
    this.lastPotentialJobId = potentialJobId;
    this.potentialJobsDefaultCostCodeService.getDefaultCostCodesByDeparmentId(departmentId).subscribe(
      res => this.getJobDefaultCostCodeDataOnSuccess(res),
      error => this.getDefaultCostCodeDataOnError(error),
    );
  }

  //On success of get task code
  getJobDefaultCostCodeDataOnSuccess(result) {
    if (result) {
      if (result.data) {
        let newObj = [];
        result.data.forEach(element => {
          if (!newObj[element.potential_job_default_cost_code_group_id]) {
            newObj[element.potential_job_default_cost_code_group_id] = [];
          }
          newObj[element.potential_job_default_cost_code_group_id].push(element);
        });

        let index = 0,
          index2 = 0,
          recreateObj = [];
        newObj.forEach((element, ind) => {
          if (!recreateObj[index2]) {
            recreateObj[index2] = [];
          }
          recreateObj[index2][index] = element;
          if (index < 2) {
            index++;
          } else {
            index = 0;
            index2++;
          }
        });

        this.jobDefaultCostCodeData = recreateObj;
        this.costCodesLoaded = true;
      }
    }
  }

  //On error of get task code
  getDefaultCostCodeDataOnError(error) {}

  //To get custom cost code data
  getCustomCostCodeData() {
    this.potentialJobsCustomCostCodeService.getCustomCostCode(this.jobId).subscribe(
      res => this.getJobCustomCostCodeDataOnSuccess(res),
      error => this.getCustomCostCodeDataOnError(error),
    );
  }

  //On success of get task code
  getJobCustomCostCodeDataOnSuccess(result) {
    if (result) {
      if (result.data) {
        this.jobDepartmentCustomCostCodeData = result.data;
        setTimeout(() => {
          this.createDepartmentCustomCostCodeDetailForm();
        }, 500);
      }
    }
  }

  //On error of get task code
  getCustomCostCodeDataOnError(error) {}

  //Set selected task code
  setSelectedTaskCodes(event, item) {
    let checkEvent = event == true ? event : event.target.checked;
    if (checkEvent) {
      if (!this.jobDepartmentTaskCodes[item.department_id]) {
        this.jobDepartmentTaskCodes[item.department_id] = [];
      }
      let existDepartmentCostCode = this.jobDepartmentCostCodeDetailForm
        .get('jobDepartmentCostCode_' + item.department_id)
        ['controls'][0].controls.indi_costcode.value.filter(function (data, index) {
          return data.potential_job_default_cost_code_id == item.id;
        });
      if (existDepartmentCostCode.length <= 0) {
        let existJobDepdata = this.jobDepartmentTaskCodes[item.department_id].filter(function (existJobDepData) {
          return existJobDepData.id == item.id;
        });
        if (existJobDepdata.length <= 0) {
          this.jobDepartmentTaskCodes[item.department_id].push(item);
        }
      }
      this.deleteDepartmentCostCodeId = this.deleteDepartmentCostCodeId.filter(function (delItem) {
        return item.id != delItem.id;
      });
    } else {
      this.deleteDepartmentCostCodeId.push(item);
      if (this.jobDepartmentTaskCodes[item.department_id]) {
        this.jobDepartmentTaskCodes[item.department_id] = this.jobDepartmentTaskCodes[item.department_id].filter(
          function (data, index) {
            return data.id != item.id;
          },
        );
      }
    }
  }

  //On submit selected cost codes
  submitJobCostCodes() {
    let checkValid = true;

    this.jobDepartmentCustomCostCodeDetailForm
      .get('jobDepartmentCustomCostCode_' + this.lastJobCostCodeDeparrmentSelection)
      ['controls'][0].controls.indi_costcode.value.forEach(async (element, index) => {
        let checkValidCostCodes = await this.checkValidCostCodes(element, index);
        if (!checkValidCostCodes) {
          checkValid = false;
        }
      });

    setTimeout(() => {
      if (checkValid) {
        this.costCodeCloseBtn.nativeElement.click();

        if (this.jobDepartmentTaskCodes[this.lastJobCostCodeDeparrmentSelection]) {
          this.jobDepartmentTaskCodes[this.lastJobCostCodeDeparrmentSelection].forEach(async element => {
            let existData = this.jobDepartmentCostCodeDetailForm
              .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
              ['controls'][0].controls.indi_costcode.value.filter(function (item) {
                return item.potential_job_default_cost_code_id == element.id;
              });
            if (existData.length <= 0) {
              await this.addNewCostCode(element);
            }
          });
        }

        if (this.jobDepartmentCustomCostCodeDetailForm) {
          this.jobDepartmentCustomCostCodeDetailForm
            .get('jobDepartmentCustomCostCode_' + this.lastJobCostCodeDeparrmentSelection)
            ['controls'][0].controls.indi_costcode.value.forEach(async (element, index) => {
              await this.addUpdateNewCustomCostCode(element, index);
            });
        }

        if (this.deleteDepartmentCostCodeId && this.deleteDepartmentCostCodeId.length > 0) {
          this.markDirty = true;
          this.jobDepartmentCostCodeDetailForm.markAsDirty;
          this.deleteDepartmentCostCodeId.forEach((item, index) => {
            this.jobDepartmentCostCodeDetailForm
              .get('jobDepartmentCostCode_' + item.department_id)
              ['controls'][0].controls.indi_costcode.value.forEach((element, index) => {
                if (element.potential_job_default_cost_code_id == item.id) {
                  this.jobDepartmentCostCodeDetailForm
                    .get('jobDepartmentCostCode_' + item.department_id)
                    ['controls'][0].controls.indi_costcode.removeAt(index);
                  if (element.id != '' && element.id != null) {
                    this.potentialJobCostCodesService.deletePotentialJobCostCode(element.id).subscribe(
                      res => console.log(res),
                      err => console.error(err),
                    );
                  }
                }
              });
          });
        }
      }
    }, 1000);
  }

  async checkValidCostCodes(element, index) {
    return new Promise((resolve, reject) => {
      if (
        (element.pos1 != null &&
          element.pos2 != null &&
          element.pos3 != null &&
          element.pos4 != null &&
          element.description != null &&
          element.pos1 != '' &&
          element.pos2 != '' &&
          element.pos3 != '' &&
          element.pos4 != '' &&
          element.description != '') ||
        ((element.pos1 == null || element.pos1 == '') &&
          (element.pos2 == null || element.pos2 == '') &&
          (element.pos3 == null || element.pos3 == '') &&
          (element.pos4 == null || element.pos4 == '') &&
          (element.description == null || element.description == ''))
      ) {
        let checkExistCodeArr = [];
        checkExistCodeArr['job_id'] = this.jobId;
        checkExistCodeArr['department_id'] = this.lastJobCostCodeDeparrmentSelection;
        checkExistCodeArr['pos1'] = element.pos1.toUpperCase();
        checkExistCodeArr['pos2'] = element.pos2.toUpperCase();
        checkExistCodeArr['pos3'] = element.pos3.toUpperCase();
        checkExistCodeArr['pos4'] = element.pos4.toUpperCase();
        let isDuplicate = this.checkDuplicate(checkExistCodeArr);
        if (isDuplicate) {
          // isExistCode = true;

          document
            .getElementById('pos1_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('invalid');
          document
            .getElementById('pos2_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('invalid');
          document
            .getElementById('pos3_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('invalid');
          document
            .getElementById('pos4_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('invalid');
          document
            .getElementById('duplicate_error_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.remove('hide');
          resolve(false);
        } else {
          document
            .getElementById('pos1_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.remove('invalid');
          document
            .getElementById('pos2_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.remove('invalid');
          document
            .getElementById('pos3_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.remove('invalid');
          document
            .getElementById('pos4_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.remove('invalid');
          document
            .getElementById('description_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.remove('invalid');
          document
            .getElementById('duplicate_error_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('hide');
          resolve(true);
        }
      } else {
        if (element.pos1 == null || element.pos1 == '') {
          document
            .getElementById('pos1_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('invalid');
        }
        if (element.pos2 == null || element.pos2 == '') {
          document
            .getElementById('pos2_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('invalid');
        }
        if (element.pos3 == null || element.pos3 == '') {
          document
            .getElementById('pos3_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('invalid');
        }
        if (element.pos4 == null || element.pos4 == '') {
          document
            .getElementById('pos4_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('invalid');
        }
        if (element.description == null || element.description == '') {
          document
            .getElementById('description_' + this.lastJobCostCodeDeparrmentSelection + '_' + index)
            .classList.add('invalid');
        }
        resolve(false);
      }
    });
  }

  async addNewCostCode(element) {
    return new Promise(async (resolve, reject) => {
      if (element && element != '' && element != null && element != undefined) {
        this.markDirty = true;
        let newCostCodeArr = {};
        // newCostCodeArr['job_id'] = this.jobId;
        newCostCodeArr['potential_job_id'] = this.lastPotentialJobId;
        newCostCodeArr['department_id'] = element.department_id;
        newCostCodeArr['potential_job_default_cost_code_id'] = element.id;
        newCostCodeArr['potential_job_custom_cost_code_id'] = '';
        newCostCodeArr['defaultPos1'] = element.pos1.toUpperCase();
        newCostCodeArr['defaultPos2'] = element.pos2.toUpperCase();
        newCostCodeArr['defaultPos3'] = element.pos3.toUpperCase();
        newCostCodeArr['defaultPos4'] = element.pos4.toUpperCase();
        newCostCodeArr['defaultDescription'] = element.description;
        newCostCodeArr['created_date'] = this.momentService.getDBDateTimeFormat();
        await this.addPotentialJobCostCode(newCostCodeArr, element);
      } else {
        reject(false);
      }
    });
  }

  async addPotentialJobCostCode(newCostCodeArr, element) {
    return new Promise((resolve, reject) => {
      this.potentialJobCostCodesService.addPotentialJobCostCode(newCostCodeArr).subscribe(
        res => {
          if (res.data) {
            newCostCodeArr['id'] = res.data.id;
            this.addAdditionalCostCodeInfoSameEditTime(
              this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + newCostCodeArr['department_id'])[
                'controls'
              ][0].controls.indi_costcode,
              newCostCodeArr,
            );
            resolve(true);
          }
        },
        err => reject(false),
      );
    });
  }

  async addUpdateNewCustomCostCode(element, index) {
    return new Promise(async (resolve, reject) => {
      let newArr = {};
      if (element.id != null && element.id != 0) {
        await this.updateCustomCostCode(element);
        this.jobDepartmentCostCodeDetailForm
          .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
          ['controls'][0].controls.indi_costcode.value.forEach((item, index) => {
            if (element.id == item.id) {
              this.jobDepartmentCostCodeDetailForm
                .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
                ['controls'][0].controls.indi_costcode.controls[index].controls.pos1.setValue(element.pos1);
              this.jobDepartmentCostCodeDetailForm
                .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
                ['controls'][0].controls.indi_costcode.controls[index].controls.pos2.setValue(element.pos2);
              this.jobDepartmentCostCodeDetailForm
                .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
                ['controls'][0].controls.indi_costcode.controls[index].controls.pos3.setValue(element.pos3);
              this.jobDepartmentCostCodeDetailForm
                .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
                ['controls'][0].controls.indi_costcode.controls[index].controls.pos4.setValue(element.pos4);
              this.jobDepartmentCostCodeDetailForm
                .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
                [
                  'controls'
                ][0].controls.indi_costcode.controls[index].controls.description.setValue(element.description);
            }
          });
        resolve(true);
      } else {
        if (
          (element.pos1 == null || element.pos1 == '') &&
          (element.pos2 == null || element.pos2 == '') &&
          (element.pos3 == null || element.pos3 == '') &&
          (element.pos4 == null || element.pos4 == '') &&
          (element.description == null || element.description == '') &&
          this.jobDepartmentCustomCostCodeDetailForm.get(
            'jobDepartmentCustomCostCode_' + this.lastJobCostCodeDeparrmentSelection,
          )['controls'][0].controls.indi_costcode.value.length > 1
        ) {
          this.jobDepartmentCustomCostCodeDetailForm
            .get('jobDepartmentCustomCostCode_' + this.lastJobCostCodeDeparrmentSelection)
            ['controls'][0].controls.indi_costcode.removeAt(index);
          resolve(true);
        } else {
          if (
            element.pos1 != null &&
            element.pos1 != '' &&
            element.pos2 != null &&
            element.pos2 != '' &&
            element.pos3 != null &&
            element.pos3 != '' &&
            element.pos4 != null &&
            element.pos4 != '' &&
            element.description != null &&
            element.description != ''
          ) {
            // newArr['job_id'] = this.jobId;
            let duplicateCustomData = this.jobDepartmentCostCodeDetailForm
              .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
              ['controls'][0].controls.indi_costcode.value.filter(function (data) {
                return (
                  data.pos1.toUpperCase() == element.pos1.toUpperCase() &&
                  data.pos2.toUpperCase() == element.pos2.toUpperCase() &&
                  data.pos3.toUpperCase() == element.pos3.toUpperCase() &&
                  data.pos4.toUpperCase() == element.pos4.toUpperCase()
                );
              });
            if (duplicateCustomData.length <= 0) {
              newArr['potential_job_id'] = this.lastPotentialJobId;
              newArr['department_id'] = this.lastJobCostCodeDeparrmentSelection;
              newArr['pos1'] = element.pos1.toUpperCase();
              newArr['pos2'] = element.pos2.toUpperCase();
              newArr['pos3'] = element.pos3.toUpperCase();
              newArr['pos4'] = element.pos4.toUpperCase();
              newArr['description'] = element.description;
              newArr['created_date'] = this.momentService.getDBDateTimeFormat();
              newArr['updated_date'] = this.momentService.getDBDateTimeFormat();
              this.markDirty = true;
              this.jobDepartmentCostCodeDetailForm.markAsDirty;
              this.potentialJobsCustomCostCodeService.createCustomCostCode(newArr).subscribe(
                async res => {
                  if (res.data) {
                    let newCustomCostCodeArr = {};
                    // newCustomCostCodeArr['job_id'] = this.jobId;
                    newCustomCostCodeArr['potential_job_id'] = this.lastPotentialJobId;
                    newCustomCostCodeArr['department_id'] = this.lastJobCostCodeDeparrmentSelection;
                    newCustomCostCodeArr['potential_job_default_cost_code_id'] = '';
                    newCustomCostCodeArr['potential_job_custom_cost_code_id'] = res.data.id;
                    newCustomCostCodeArr['customPos1'] = element.pos1.toUpperCase();
                    newCustomCostCodeArr['customPos2'] = element.pos2.toUpperCase();
                    newCustomCostCodeArr['customPos3'] = element.pos3.toUpperCase();
                    newCustomCostCodeArr['customPos4'] = element.pos4.toUpperCase();
                    newCustomCostCodeArr['customDescription'] = element.description;
                    newCustomCostCodeArr['created_date'] = this.momentService.getDBDateTimeFormat();
                    this.markDirty = true;
                    await this.addPotentialJobCostCode(newCustomCostCodeArr, element);
                    // this.addAdditionalCostCodeInfoSameEditTime(this.jobDepartmentCostCodeDetailForm.get("jobDepartmentCostCode_" + this.lastJobCostCodeDeparrmentSelection)['controls'][0].controls.indi_costcode, newCustomCostCodeArr);
                    // }

                    resolve(true);
                  } else {
                    reject(false);
                  }
                },
                err => reject(false),
              );
            } else {
              reject(false);
            }
          } else {
            resolve(true);
          }
        }
      }
    });
  }

  async updateCustomCostCode(element) {
    return new Promise((resolve, reject) => {
      let newArr = {};
      newArr['id'] = element.id;
      // newArr['job_id'] = this.jobId;
      newArr['potential_job_id'] = this.lastPotentialJobId;
      // newArr['department_id'] = this.lastJobCostCodeDeparrmentSelection;
      newArr['pos1'] = element.pos1.toUpperCase();
      newArr['pos2'] = element.pos2.toUpperCase();
      newArr['pos3'] = element.pos3.toUpperCase();
      newArr['pos4'] = element.pos4.toUpperCase();
      newArr['description'] = element.description;
      newArr['updated_date'] = this.momentService.getDBDateTimeFormat();
      this.potentialJobsCustomCostCodeService.updateCustomCostCode(element.id, newArr).subscribe(
        res => resolve(true),
        err => reject(false),
      );
    });
  }

  triggerCloseModal(id: string | number) {
    this.closeModal(id);
  }

  checkDuplicate(data) {
    if (data) {
      let flag = 0,
        count = 0;
      this.jobDefaultCostCodeData.forEach(item => {
        item.forEach(itemArr => {
          itemArr.forEach(element => {
            if (
              data.pos1.toUpperCase() == element.pos1 &&
              data.pos2.toUpperCase() == element.pos2 &&
              data.pos3.toUpperCase() == element.pos3 &&
              data.pos4.toUpperCase() == element.pos4
            ) {
              count = count + 1;
            }
          });
        });
      });

      let duplicateCustomData = this.jobDepartmentCustomCostCodeDetailForm
        .get('jobDepartmentCustomCostCode_' + this.lastJobCostCodeDeparrmentSelection)
        ['controls'][0].controls.indi_costcode.value.filter(function (element) {
          return (
            data.pos1.toUpperCase() == element.pos1.toUpperCase() &&
            data.pos2.toUpperCase() == element.pos2.toUpperCase() &&
            data.pos3.toUpperCase() == element.pos3.toUpperCase() &&
            data.pos4.toUpperCase() == element.pos4.toUpperCase()
          );
        });
      if (duplicateCustomData.length > 1 || count > 0) {
        flag = 1;
      }
      if (flag == 1) {
        return 1;
      } else {
        return 0;
      }
    } else {
      return false;
    }
  }

  //To set check box checked in modal
  getCheckedStatus(departmentId, costCode) {
    if (
      this.jobDepartmentCostCodeDetailForm &&
      this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + departmentId)
    ) {
      let existData = this.jobDepartmentCostCodeDetailForm
        .get('jobDepartmentCostCode_' + departmentId)
        ['controls'][0].controls.indi_costcode.value.filter(function (item) {
          return item.potential_job_default_cost_code_id == costCode.id;
        });
      if (existData.length > 0) {
        return 1;
      } else {
        if (
          this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + departmentId)['controls'][0].controls
            .indi_costcode.value.length <= 0
        ) {
          if (costCode.pre_selected) {
            this.setSelectedTaskCodes(true, costCode);
            return 1;
          }
        } else {
          return 0;
        }
      }
    } else {
      return 0;
    }
  }

  //Check if department code code data exist
  isDepartmentCostCodeExist(departmentId) {
    if (this.jobDepartmentCostCodeDetailForm) {
      if (this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + departmentId)) {
        let existData = this.jobDepartmentCostCodeDetailForm
          .get('jobDepartmentCostCode_' + departmentId)
          ['controls'][0].controls.indi_costcode.value.filter(function (item) {
            return item.department_id == departmentId;
          });
        if (existData.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  //To generate default cost code form if not exist
  checkGenerateCustomCostCodeForm(departmentId) {
    if (!this.jobDepartmentCustomCostCodeDetailForm.get('jobDepartmentCustomCostCode_' + departmentId)) {
      this.jobDepartmentCustomCostCodeDetailForm.addControl(
        'jobDepartmentCustomCostCode_' + departmentId,
        this.formBuilder.array([this.addAdditionalCustomCostCodeInfoRows()]),
      );
      this.jobDepartmentCostCodeDetailForm.addControl(
        'jobDepartmentCostCode_' + departmentId,
        this.formBuilder.array([this.addAdditionalCostCodeInfoRows()]),
      );
    }
    return 'jobDepartmentCustomCostCode_' + departmentId;
  }

  //To delete custom cost code
  deleteCustomCostCode(item, j) {
    if (item.id != null && item.id != 0 && item.id != '' && item.id != undefined) {
      this.potentialJobsCustomCostCodeService.deleteCustomCostCode(item.id).subscribe(
        res => console.log(res),
        err => console.log(err),
      );

      this.jobDepartmentCostCodeDetailForm
        .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
        ['controls'][0].controls.indi_costcode.value.forEach((element, index) => {
          if (element.potential_job_custom_cost_code_id == item.id) {
            this.jobDepartmentCostCodeDetailForm
              .get('jobDepartmentCostCode_' + this.lastJobCostCodeDeparrmentSelection)
              ['controls'][0].controls.indi_costcode.removeAt(index);
            if (element.id != '' && element.id != null) {
              this.potentialJobCostCodesService.deletePotentialJobCostCode(element.id).subscribe(
                res => console.log(res),
                err => console.error(err),
              );
            }
          }
        });
    }
    this.jobDepartmentCustomCostCodeDetailForm
      .get('jobDepartmentCustomCostCode_' + this.lastJobCostCodeDeparrmentSelection)
      ['controls'][0].controls.indi_costcode.removeAt(j);
  }

  checkToAddNewCostCode(j, costCodeCtrl) {
    let existDataCount = this.jobDepartmentCustomCostCodeDetailForm.get(
      'jobDepartmentCustomCostCode_' + this.lastJobCostCodeDeparrmentSelection,
    )['controls'][0].controls.indi_costcode.value.length;
    if (existDataCount == j + 1) {
      this.addAdditionalCustomCostCodeInfoSameEditTime(costCodeCtrl);
      setTimeout(() => {
        document.getElementById('pos1_' + this.lastJobCostCodeDeparrmentSelection + '_' + (j + 1)).focus();
      }, 100);
    }
  }

  //To get total of defined field and department
  getTotalOfDepartment(field, departmentId, subCost?: number) {
    let total = 0;
    if (this.jobDepartmentCostCodeDetailForm) {
      if (this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + departmentId)) {
        const resultData = this.jobDepartmentCostCodeDetailForm
          .get('jobDepartmentCostCode_' + departmentId)
          ['controls'][0].controls.indi_costcode.value.filter(element => {
            return element.department_id == departmentId;
          });

        if (resultData.length > 0) {
          resultData.forEach(element => {
            if (element[field] != '' && element[field] != null && element[field] != undefined) {
              if (typeof element[field] == 'string' && element[field].indexOf('$') > -1) {
                element[field] = element[field].slice(1);
              }
              if (element[field].length > 3) {
                total = total + parseFloat(element[field].replace(/,/g, ''));
              } else {
                total = total + parseFloat(element[field]);
              }
            }
          });
        }
      }
    }

    this.jobDetail.jobContract = this.jobDetail?.jobContract ?? { departments: {} };

    if (!this.jobDetail?.jobContract?.departments) {
      const jc = this.jobDetail.jobContract;
      this.jobDetail.jobContract = { ...jc, departments: { [departmentId]: {} } };
    } else if (!this.jobDetail?.jobContract?.departments[departmentId]) {
      this.jobDetail.jobContract.departments[departmentId] = { [field]: total };
    } else {
      this.jobDetail.jobContract.departments[departmentId][field] = total;
    }

    return total;
  }

  getPercentage(department_id, contract_total) {
    return this.getTotalOfDepartment('estimated_cost', department_id) > 0
      ? ((contract_total - this.getTotalOfDepartment('estimated_cost', department_id)) /
          this.getTotalOfDepartment('estimated_cost', department_id)) *
          100
      : 0;
  }

  //Get project total
  getProjectTotal(field: string) {
    this.grandContractTotal = 0;
    this.grandEstimatedCost = 0;
    this.grandEstimatedHours = 0;
    this.grandProdUnits = 0;
    this.grandEstimatedProfit = 0;
    this.grandEstimatedGm = 0;
    if (this.jobDetailForm && this.jobDetailForm.get('department')) {
      this.jobDetailForm.get('department')['controls'][0].controls.sub_department.value.forEach(element => {
        let estimatedCostTotal = 0;
        if (element != null) {
          if (
            element.contract_total != null &&
            element.contract_total != '' &&
            !Number.isNaN(parseFloat(element.contract_total))
          ) {
            this.grandContractTotal += parseFloat(element.contract_total);
          }
          if (this.jobDepartmentCostCodeDetailForm) {
            if (this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + element.department_id)) {
              this.jobDepartmentCostCodeDetailForm
                .get('jobDepartmentCostCode_' + element.department_id)
                ['controls'][0].controls.indi_costcode.value.forEach(element1 => {
                  if (element1.estimated_cost != null && element.estimated_cost != '' && element1.estimated_cost) {
                    if (typeof element1.estimated_cost == 'string') {
                      element1.estimated_cost = element1.estimated_cost.replace('$', '');
                      element1.estimated_cost = element1.estimated_cost.replace(/,/g, '');
                    }
                    if (!Number.isNaN(element1.estimated_cost) && !Number.isNaN(parseFloat(element1.estimated_cost))) {
                      this.grandEstimatedCost += parseFloat(element1.estimated_cost);
                      estimatedCostTotal += parseFloat(element1.estimated_cost);
                    }
                  }
                  if (element1.estimated_hours != null && element.estimated_hours != '') {
                    this.grandEstimatedHours += parseFloat(element1.estimated_hours);
                  }

                  if (element1.prod_units != null && element.prod_units != '') {
                    this.grandProdUnits += parseFloat(element1.prod_units);
                  }
                });
            }
            this.grandEstimatedProfit += element.contract_total - estimatedCostTotal;
          }
        }
      });
    }

    let total = 0;

    if (field == 'contract_total') {
      total = this.grandContractTotal;
    } else if (field == 'estimated_cost') {
      total = this.grandEstimatedCost;
    } else if (field == 'estimated_hours') {
      total = this.grandEstimatedHours;
    } else if (field == 'prod_units') {
      total = this.grandProdUnits;
    } else if (field == 'estimated_profit') {
      total = this.grandEstimatedProfit;
    } else if (field == 'estimated_gm') {
      if (
        this.grandEstimatedProfit != null &&
        this.grandEstimatedProfit != 0 &&
        this.grandEstimatedCost != null &&
        this.grandEstimatedCost != 0
      ) {
        total = this.grandEstimatedGm = (this.grandEstimatedProfit / this.grandEstimatedCost) * 100;
      }
    }

    this.jobDetail.jobContract = this.jobDetail?.jobContract ?? { totals: {} };
    this.jobDetail.jobContract.totals[field] = total;

    return total;
  }

  setDataToControl(field: string, value: string) {
    const defaultSelectedIndex = 0;
    const result = this.arCustomerData.find(item => item.id == value);

    if (field === 'contact_ar_customer_name_id') {
      if (!result) return this.loadErrorStatus();

      this.jobDetailForm.get('contact_ar_customer_id').setValue(result.id);
      this.jobDetailForm.get('contact_ar_customer_name_id').setValue(result.id);
      this.jobDetailForm.get('billing_contacts_preferred_index').setValue(defaultSelectedIndex);

      const address = result.name + '\n' + this.customerService.getFormattedAddress(result);

      if (address) {
        const contact = result?.billing_contacts.contacts[defaultSelectedIndex];
        this.billingContacts = result?.billing_contacts.contacts;

        this.jobDetailForm.get('contact_address1').setValue(address);
        this.jobDetailForm.get('additional_billing_contact_name').setValue(contact?.contactName || '');
        this.jobDetailForm.get('additional_contact_email').setValue(contact?.contactEmail || '');
        this.jobDetailForm.get('additional_contact_phone_number').setValue(contact?.phoneNumber || '');
        this.jobDetailForm.get('additional_portal_website_address').setValue(contact?.billingEmail || '');
        this.jobDetailForm.get('additional_portal_notes').setValue(contact?.billingNote || '');

        this.loadtextAreaPlaceHolder();
      }

      this.triggerChange('#contact_ar_customer_id');
      this.triggerChange('#contact_ar_customer_name_id');
      this.triggerChange('#contact_address1');
      this.triggerChange('#additional_billing_contact_name');
    }

    if (field === 'contact_ar_customer_id') {
      if (!result) return this.loadErrorStatus();

      this.jobDetailForm.get('contact_ar_customer_id').setValue(result.id);
      this.jobDetailForm.get('contact_ar_customer_name_id').setValue(result.id);
      this.jobDetailForm.get('billing_contacts_preferred_index').setValue(defaultSelectedIndex);

      const address = result.name + '\n' + this.customerService.getFormattedAddress(result);

      if (address) {
        const contact = result?.billing_contacts.contacts[defaultSelectedIndex];
        this.billingContacts = result?.billing_contacts.contacts;

        this.jobDetailForm.get('contact_address1').setValue(address);
        this.jobDetailForm.get('additional_billing_contact_name').setValue(contact?.contactName || '');
        this.jobDetailForm.get('additional_contact_email').setValue(contact?.contactEmail || '');
        this.jobDetailForm.get('additional_contact_phone_number').setValue(contact?.phoneNumber || '');
        this.jobDetailForm.get('additional_portal_website_address').setValue(contact?.billingEmail || '');
        this.jobDetailForm.get('additional_portal_notes').setValue(contact?.billingNote || '');

        this.loadtextAreaPlaceHolder();
      }

      this.triggerChange('#contact_ar_customer_id');
      this.triggerChange('#contact_ar_customer_name_id');
      this.triggerChange('#contact_address1');
      this.triggerChange('#additional_billing_contact_name');
    }

    if (field === 'additional_billing_contact_name') {
      // Get the entry that was selected from billingContacts.
      const res = this.billingContacts.find(el => el.contactName === value);

      if (!res) return this.loadErrorStatus();

      // From the found entry, set all the fields to the proper value.
      this.jobDetailForm.get('additional_contact_email').setValue(res.contactEmail);
      this.jobDetailForm.get('additional_contact_phone_number').setValue(res.phoneNumber);
      this.jobDetailForm.get('additional_portal_website_address').setValue(res.billingEmail);
      this.jobDetailForm.get('additional_portal_notes').setValue(res.billingNote);

      // Set the preferred index for when we save the changes.
      const index = this.billingContacts.indexOf(res);
      this.jobDetailForm.get('billing_contacts_preferred_index').setValue(index);
    }

    const val = field === 'name' ? value.toUpperCase() : value;

    this.jobDetailForm.get(field).setValue(val);
    this.loadErrorStatus();
  }

  setDataToGroupControl(formGroupArray, field, value) {
    formGroupArray.get(field).setValue(value);
    formGroupArray.get(field).markAsDirty();
    this.jobDetailForm.get(field)?.setValue(value);
    this.jobDetailForm.get(field)?.markAsDirty();

    // formGroupArray TODO: Mark dirty
    this.loadErrorStatus();
  }

  setDataToPermitControl(permittype, field, value, index = null) {
    permittype.get(field).setValue(value);
    this.addPermitType(permittype.value);
  }

  setCostCodeDataToControl(costcode, field, value, index = null) {
    costcode.get(field).setValue(value);
  }

  setFileUploadSection(field) {
    this.attachSchedulefiles = [];
    this.lastFileUploadSection = field;
  }

  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  onDrop(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      this.attachSchedulefiles.push(files.item(i));
    }
    setTimeout(() => {
      this.clearFile('#dropZoneFile');
    }, 500);
  }

  startUpload() {
    this.attachSchedulefiles.forEach(async (file, index) => {
      await this.setFile(file);
    });
  }

  setFile(file) {
    return new Promise(resolve => {
      const section = this.lastFileUploadSection;
      const cleanName = file.name.replaceAll(',', ' ');
      Object.defineProperty(file, 'name', { writable: true, value: cleanName });

      if (!this.fileList[section]) this.fileList[section] = [];
      if (!this.fileList[section + '_filenames']) this.fileList[section + '_filenames'] = [];

      if (
        section === 'financial_attach_other_document' ||
        section === 'contract_attach_project_purchase_order' ||
        section === 'labor_attach_schedule' ||
        section === 'additional_per_diem_documents' ||
        section === 'additional_attach_targeting_contact' ||
        section === 'sales_tax_attach_exemption_certificate'
      ) {
        if (!this.fileList[section + '_media_ids']) this.fileList[section + '_media_ids'] = [];

        const formData = new FormData();
        formData.append('parentType', 'potential_job_details');
        formData.append('parentId', this.jobId);
        formData.append('category', section);
        formData.append('files', file);

        this.mediaService.create.potential_jobs(formData).subscribe(
          res => {
            const records: any[] = res?.data || [];
            records.forEach(record => {
              this.fileList[section].push(record.url);
              this.fileList[section + '_filenames'].push(record.name);
              this.fileList[section + '_media_ids'].push(record.id);
            });
            resolve(true);
          },
          err => {
            console.error('File upload failed:', err);
            resolve(false);
          },
        );
      } else {
        let pathName,
          dotIndex = file.name.lastIndexOf('.');
        if (dotIndex > -1) {
          pathName = `${file.name.substring(0, dotIndex)}_${Date.now()}${file.name.substring(dotIndex)}`;
        } else {
          pathName = `${file.name}_${Date.now()}`;
        }

        const path = `uploads/jobs/${pathName}`;
        const ref = this.storage.ref(path);
        this.task = this.storage.upload(path, file);

        this.task
          .snapshotChanges()
          .pipe(
            tap(console.log),
            finalize(async () => {
              this.downloadURL = ref.getDownloadURL();
              await this.downloadURL.subscribe(url => {
                if (url) {
                  this.fileList[section + '_filenames'].push(file.name);
                  this.fileList[section].push(url);
                  resolve(true);
                }
              });
            }),
          )
          .subscribe();
      }
    });
  }

  getCssClassName(statusName: string) {
    return statusName.toLowerCase().replace(/ /g, '-');
  }

  isActive(snapshot) {
    return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes;
  }

  removeFile(index, field, file) {
    const mediaId = this.fileList[field + '_media_ids']?.[index];
    if (mediaId) {
      this.mediaService.delete.potential_jobs(mediaId).subscribe({
        error: err => console.error('Failed to delete media record:', err),
      });
      this.fileList[field + '_media_ids'].splice(index, 1);
    }
    this.fileList[field].splice(index, 1);
    this.jobDetailForm.get(field).setValue(this.fileList[field].join(','));
    this.fileList[field + '_filenames'].splice(index, 1);
    this.jobDetailForm.get(field + '_filenames').setValue(this.fileList[field + '_filenames'].join(','));
  }

  removeAttachment(index: number) {
    this.attachSchedulefiles.splice(index, 1);
  }

  extractFileString(arrayString) {
    const lastSlash = arrayString.lastIndexOf('/');
    return arrayString.substring(lastSlash + 1);
  }

  loadErrorStatus() {
    setTimeout(() => {
      this.loadSelect2Error();
    }, 200);
  }

  downloadSageExportPDF() {
    this.loaderService.displayLoader();
    const jobDataArr = {};
    jobDataArr['job_details'] = this.jobDetailForm.get('department').value[0]['sub_department'];
    jobDataArr['job'] = this.jobDetailForm.value;
    jobDataArr['contract_total'] = this.grandContractTotal;
    jobDataArr['estimated_cost'] = this.grandEstimatedCost;
    jobDataArr['job'].job_creation_date = this.initialValue[0].job_creation_date;
    jobDataArr['job'].contract_size = this.initialValue[0].contract_size;

    this.jobsService.downloadSageExport(jobDataArr).subscribe(
      (response: any) => {
        this.loaderService.hideLoader();
        const blob = new Blob([response.body], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        const disposition = response.headers?.get('Content-Disposition');
        const match = disposition && disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        a.download = match ? match[1].replace(/['"]/g, '') : 'sage-export.pdf';
        a.href = url;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      err => {
        this.loaderService.hideLoader();
      },
    );
  }

  getFormDetail(field: string) {
    if (field) {
      return this.jobDetailForm.get(field).value;
    }
  }

  getFormArrayDetail(array, key_field, value, field) {
    if (!array || !Array.isArray(array)) return '-';

    const element = array.find(item => item[key_field] == value);

    return element ? element[field] : '-';
  }

  getTrueFalseIcon(value) {
    if (value == 1) {
      return `<i class="fas fa-ellipsis-v"></i>`;
    }
    return `<i class="fas fa-times"></i>`;
  }

  getSubDepartment(index: string, field: string, key?: string) {
    if (this.jobDetailForm.get('department')) {
      if (this.jobDetailForm.get('department').value[0]['sub_department'][index]) {
        let data = this.jobDetailForm.get('department').value[0]['sub_department'][index];
        if (field == 'department_name') {
          return data.department_name;
        } else if (field == 'project_manager_id') {
          const pm = this.projectManagerData.find(item => {
            return item.id == data.project_manager_id;
          });

          if (pm && key) return pm[key] ?? '';

          return pm ? pm.first_name + ' ' + pm.last_name : '';
        } else if (field == 'assistant_id') {
          const pa = this.ProjectAssistantData.find(item => {
            return item.id == data.assistant_id;
          });

          if (pa && key) return pa[key] ?? '';

          return pa ? pa.first_name + ' ' + pa.last_name : '';
        } else if (field == 'partner_assistant_id') {
          const pa = this.ProjectAssistantData.find(item => {
            return item.id == data.partner_assistant_id;
          });

          if (pa && key) return pa[key] ?? '';

          return pa ? pa.first_name + ' ' + pa.last_name : '';
        } else if (field == 'foreman_id') {
          const fm = this.projectForemanData.find(item => {
            return item.id == data.foreman_id;
          });

          if (fm && key) return fm[key] ?? '';

          return fm ? fm.first_name + ' ' + fm.last_name : '';
        } else if (field == 'estimator_id') {
          let projectEstimatorDataArr = this.projectEstimatorData.filter(function (item) {
            return item.id == data.estimator_id;
          });
          if (projectEstimatorDataArr.length > 0) {
            return projectEstimatorDataArr[0].first_name + ' ' + projectEstimatorDataArr[0].last_name;
          }
        }
      }
    } else {
      return '';
    }
  }

  dateCompareValidator(controlName: string, compareControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const compareControl = formGroup.controls[compareControlName];
      if (compareControl.errors && !compareControl.errors.dateCompareValidator) {
        return;
      }
      if (
        this.momentService.getCurrentFullDate(this.momentService.getDBDateFormat(control.value)) >
        this.momentService.getCurrentFullDate(this.momentService.getDBDateFormat(compareControl.value))
      ) {
        compareControl.setErrors({ dateCompareValidator: true });
      } else {
        compareControl.setErrors(null);
      }
    };
  }

  websiteBillingValidator(controlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];

      const EMAIL_REGEXP =
        /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
      const WEBSITE_URL =
        /^((https?|ftp|smtp|http):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

      if (control.errors && !control.errors.websiteBillingValidator) {
        return;
      }

      if (control.value && !EMAIL_REGEXP.test(control.value) && !WEBSITE_URL.test(control.value)) {
        control.setErrors({ websiteBillingValidator: true });
      } else {
        control.setErrors(null);
      }
    };
  }

  confirmedValidator(controlName: string, childControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const childControl = formGroup.controls[childControlName];
      if (childControl.errors && !childControl.errors.confirmedValidator) {
        return;
      }
      if (
        control.value == 1 &&
        (childControl.value == '' || childControl.value == null || childControl.value == undefined)
      ) {
        childControl.setErrors({ confirmedValidator: true });
      } else {
        childControl.setErrors(null);
      }
    };
  }

  exemptNotesValidator(controlName: string, childControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const childControl = formGroup.controls[childControlName];
      if (childControl.errors && !childControl.errors.exemptNotesValidator) {
        return;
      }
      if (
        control.value == 3 &&
        (childControl.value == '' || childControl.value == null || childControl.value == undefined)
      ) {
        childControl.setErrors({ exemptNotesValidator: true });
      } else {
        childControl.setErrors(null);
      }
    };
  }

  setAttributeAndValue(elem, attr, value) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `setAttributeAndValue('` + elem + `','` + attr + `','` + value + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  getPrefix(elem) {
    if (elem) {
      elem.setAttribute('prefix', '$$');
    } else {
      elem.setAttribute('prefix', '');
    }
  }

  getInputValue(elem) {
    if (parseFloat(elem.value) >= 0) {
      elem.value = '$' + elem.value;
    } else {
      elem.value = '';
    }
  }

  setInputValue(elem) {
    if (parseFloat(elem.value) >= 0) {
      elem.value = '$' + elem.value;
    } else {
      elem.value = '';
    }
  }

  setPrefix(costcode, department_id) {
    if (this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + department_id)) {
      if (
        this.jobDepartmentCostCodeDetailForm.get('jobDepartmentCostCode_' + department_id)['controls'][0].controls
          .indi_costcode.value[costcode].estimated_cost != ''
      ) {
        return '$';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  getAuditTime(date) {
    return this.momentService.getDateWithFormat(date, 'YYYY-MM-DD hh:mm:ss A');
  }

  async generateJobDetailPdf() {
    try {
      const unionLocal = this.unionLocalsData.find(el => el.id === this.jobDetail.labor_union_local_id);

      const bType = this.billingDueDateTypesData.find(el => el.id === this.jobDetail.contact_billing_due_date_type);
      const customer = this.arCustomerData.find(el => el.id == this.jobDetail.contact_ar_customer_name_id);
      const ownerFacility = this.ownersFacilityData.filter(el => el.id === this.jobDetail.facility_location_id);

      const data = {
        ...this.jobDetail,
        billing_type_description: bType?.description ?? '',
        billing_type_name: bType?.name ?? '',
        customer,
        ownerFacility,
        unionLocal,
        form: {},
      };

      const keys = Object.keys(this.jobDetailForm.controls);

      keys.forEach(el => {
        const v = this.jobDetailForm.controls[el].value;
        data.form[el] = v;

        if (el === 'department') {
          const subDepartments = v[0].sub_department.map((dept, index) => {
            const pm = this.getSubDepartment(index, 'project_manager_id', 'employee_alias');
            const fm = this.getSubDepartment(index, 'foreman_id', 'employee_alias');
            const am = this.getSubDepartment(index, 'assistant_id', 'employee_alias');
            const am2 = this.getSubDepartment(index, 'partner_assistant_id', 'employee_alias');
            const name = `${dept.number}-${dept.department_short_code}`;

            const financialData =
              this.jobDepartmentCostCodeData.filter(row => row.department_id === dept.department_id) || [];

            const additionalCostInfo = data.jobContract.departments[dept.department_id];
            const estimated_profit = dept.contract_total - additionalCostInfo.estimated_cost;

            return {
              ...dept,
              ...additionalCostInfo,
              estimated_profit,
              am,
              am2,
              fm,
              isMainJob: dept.is_main_job,
              name,
              pm,
              financialData,
            };
          });

          data.form[el] = subDepartments;
        }
      });

      const { number } = this.jobDetail;

      const today = this.momentService.getGeneralDateFormat('', 'YYYYMMDD');

      const filename = `job_${number}_${today}_export.pdf`;

      const headerContent = {
        data,
        headerTitle: '',
      };

      await this.pdfService.saveToPdf(filename, headerContent, 'jobDetail');
    } catch (error) {
      console.error('GENERATE PDF ERROR:', error);
    } finally {
      this.loaderService.hideLoader();
    }
  }
}
